import React, { useState } from 'react';
import '../styles/Automotive.css';

function Automotive() {
  const [showBalmerolCategories, setShowBalmerolCategories] = useState(false);
  const [showChemoleumCategories, setShowChemoleumCategories] = useState(false);
  const [activeBalmerolCategory, setActiveBalmerolCategory] = useState(null);
  const [activeChemoleumCategory, setActiveChemoleumCategory] = useState(null);

  const balmerolCategories = [
    "Greases",
    "Coolant",
    "Diesel Engine Oil",
    "Diesel Engine",
    "Two Wheeler",
    "Transmission Oil",
    "Gear Oil",
    "Hydraulic Oil",
    "Multigrade Engine Oil"
  ];

  const chemoleumCategories = [
    "Grease",
    "2W",
    "3W",
    "PCMO",
    "Gear/X mission",
    "Wet Brake Oil",
    "DEO",
    "Coolant",
    "Adblue"
  ];

  const greasesProducts = [
    { name: "BL AUTOPLEX 24X0.5 KG", price: 330, weight: "0.50 KG" },
    { name: "BL AUTOPLEX 12X1 KG", price: 640, weight: "1.00 KG" },
    { name: "BL AUTOPLEX 6X2 KG", price: 1265, weight: "2.00 KG" },
    { name: "BL AUTOPLEX 4X3 KG", price: 1880, weight: "3.00 KG" },
    { name: "BL AUTOPLEX 2X5 KG", price: 3120, weight: "5.00 KG" },
    { name: "BL AUTOPLEX 7 KG", price: 4320, weight: "7.00 KG" },
    { name: "BL AUTOPLEX 18 KG", price: 9485, weight: "18.00 KG" },
    { name: "BL AUTOPLEX SUPER 24X0.5 KG", price: 395, weight: "0.50 KG" },
    { name: "BL AUTOPLEX SUPER 12X1 KG", price: 765, weight: "1.00 KG" },
    { name: "BL AUTOPLEX SUPER 6X2KG", price: 1525, weight: "2.00 KG" },
    { name: "BL AUTOPLEX SUPER 4X3 KG", price: 2280, weight: "3.00 KG" },
    { name: "BL AUTOPLEX SUPER 2X5 KG", price: 3775, weight: "5.00 KG" },
    { name: "BL AUTOPLEX SUPER 7KG", price: 5259, weight: "7.00 KG" },
    { name: "BL AUTOPLEX SUPER 10 KG", price: 7455, weight: "10.00 KG" },
    { name: "BL AUTOPLEX SUPER 18 KG", price: 12250, weight: "18.00 KG" },
    { name: "BL CGX Grease 18KG", price: 5770, weight: "18.00 KG" },
    { name: "BL GREASE HDAW EP2 2X5KG", price: 2520, weight: "5.00 KG" },
    { name: "BL GREASE HDAW EP2 18 KG", price: 8600, weight: "18.00 KG" },
    { name: "BL MP 3 (N) 60 X 0.1 Kg", price: 58, weight: "0.10 KG" },
    { name: "BL MP 3 (N) 60 X 0.2 Kg", price: 110, weight: "0.20 KG" },
    { name: "BL MP 3 (N) 24X 0.5 Kg", price: 268, weight: "0.50 KG" },
    { name: "BL MP 3 (N) 12 X1 Kg", price: 524, weight: "1.00 KG" },
    { name: "BL MP 3 (N) 6X 2 Kg", price: 1030, weight: "2.00 KG" },
    { name: "BL MP 3 (N) 4X 3 Kg", price: 1535, weight: "3.00 KG" },
    { name: "BL MP 3 (N) 2X 5 Kg", price: 2535, weight: "5.00 KG" },
    { name: "BL MP 3 (N) 18KG", price: 7910, weight: "18.00 KG" },
    { name: "BL MULTIGREASE LL-RT 2X5 KG", price: 3140, weight: "5.00 KG" },
    { name: "BL MULTIGREASE LL-RT 18 KG", price: 10100, weight: "18.00 KG" },
    { name: "BL SYNTHPLEX 12X1 KG", price: 1125, weight: "1.00 KG" },
    { name: "BL SYNTHPLEX 4X3 KG", price: 3325, weight: "3.00 KG" },
    { name: "BL SYNTHPLEX 2X5 KG", price: 5400, weight: "5.00 KG" },
    { name: "BL WHEEL BEARING HD 24X0.5KG", price: 181, weight: "0.50 KG" },
    { name: "BL WHEEL BEARING HD 12X1KG", price: 361, weight: "1.00 KG" },
    { name: "BL WHEEL BEARING HD 6X2KG", price: 712, weight: "2.00 KG" },
    { name: "BL WHEEL BEARING HD 4X3KG", price: 1063, weight: "3.00 KG" },
    { name: "BL WHEEL BEARING HD 18KG", price: 5900, weight: "18.00 KG" }
  ];

  const coolantProducts = [
    { name: "BL Dekacool 10 X 1 L", price: 325, weight: "1.00 L" }
  ];

  const dieselEngineOilProducts = [
    { name: "BL CPRB 15W40 CF4 20X0.5L", price: 181, weight: "0.50 L" },
    { name: "BL CPRB 15W40 CF4 20X1L", price: 355, weight: "1.00 L" },
    { name: "BL CPRB 15W40 CF4 4X3L", price: 1050, weight: "3.00 L" },
    { name: "BL CPRB 15W40 CF4 4X5L", price: 1725, weight: "5.00 L" },
    { name: "BL CPRB 15W40 CF4 7.5L", price: 2550, weight: "7.50 L" },
    { name: "BL CPRB 15W40 CF4 10L", price: 3325, weight: "10.00 L" },
    { name: "BL CPRB 15W40 CF4 15L", price: 4980, weight: "15.00 L" },
    { name: "BL CPRB 15W40 CF4 20L", price: 6500, weight: "20.00 L" },
    { name: "BL EXCEL TURBO CH4 15W40 20x1L", price: 370, weight: "1.00 L" },
    { name: "BL EXCEL TURBO CH4 15W40 4X3L", price: 1095, weight: "3.00 L" },
    { name: "BL EXCEL TURBO CH4 15W40 2X6L", price: 2160, weight: "6.00 L" },
    { name: "BL EXCEL TURBO CH4 15W40 7.5L", price: 2670, weight: "7.50 L" },
    { name: "BL EXCEL TURBO CH4 15W40 10L", price: 3520, weight: "10.00 L" },
    { name: "BL EXCEL TURBO CH4 15W40 15L", price: 5248, weight: "15.00 L" },
    { name: "BL EXCEL TURBO CH4 15W40 20L", price: 6949, weight: "20.00 L" }
  ];

  const dieselEngineProducts = [
    { name: "BL PRD PLUS 20W40 20X0.5L", price: 185, weight: "0.50 L" },
    { name: "BL PRD PLUS 20W40 20X1L", price: 360, weight: "1.00 L" },
    { name: "BL PRD PLUS 20W40 2X6L", price: 2100, weight: "6.00 L" },
    { name: "BL PRD PLUS 20W40 7.5L", price: 2550, weight: "7.50 L" },
    { name: "BL PRD PLUS 20W40 10L", price: 3340, weight: "10.00 L" },
    { name: "BL PRD PLUS 20W40 20L", price: 6440, weight: "20.00 L" },
    { name: "BL ULTIMA CI4 PLUS 15W40 20x1L", price: 410, weight: "1.00 L" },
    { name: "BL ULTIMA CI4 PLUS 15W40 4X5L", price: 1675, weight: "5.00 L" },
    { name: "BL ULTIMA CI4 PLUS 15W40 10L", price: 3808, weight: "10.00 L" },
    { name: "BL ULTIMA CI4 PLUS 15W40 15L", price: 5820, weight: "15.00 L" },
    { name: "BL ULTIMA CI4 PLUS 15W40 20L", price: 7543, weight: "20.00 L" }
  ];

  const twoWheelerProducts = [
    { name: "BL GLIDER 4T 10X0.8L", price: 361, weight: "0.80 L" },
    { name: "BL Race 4 T Plus 10W 30 10 X 0.9 L", price: 415, weight: "0.90 L" },
    { name: "BL Race 4 T Plus 10W 30 10 X 1 L", price: 451, weight: "1.00 L" },
    { name: "BL RACE 4T 10X0.9L", price: 380, weight: "0.90 L" },
    { name: "BL RACE 4T 10X1L", price: 415, weight: "1.00 L" },
    { name: "BL SARVOTTAM PSO 4X3.5L", price: 980, weight: "3.50 L" },
    { name: "BL SUPERSTAR 4T 10X0.9L", price: 388, weight: "0.90 L" },
    { name: "BL SUPERSTAR 4T 10X1L", price: 424, weight: "1.00 L" },
    { name: "BL MOBIKE 4T 20X1L", price: 410, weight: "1.00 L" },
    { name: "BL MOBIKE 4T 20X1.2L", price: 481, weight: "1.20 L" }
  ];

  const transmissionOilProducts = [
    { name: "BL OIB Oil 20x1L", price: 334, weight: "1.00 L" },
    { name: "BL OIB Oil 4x5L", price: 1630, weight: "5.00 L" },
    { name: "BL OIB Oil 20L", price: 6400, weight: "20.00 L" },
    { name: "BL TRANS Q 20X0.5L", price: 193, weight: "0.50 L" },
    { name: "BL TRANS Q 20X1L", price: 379, weight: "1.00 L" },
    { name: "BL TRANS Q 4X5L", price: 1885, weight: "5.00 L" },
    { name: "BL TRANS Q 15L", price: 5500, weight: "15.00 L" },
    { name: "BL TRANS Q 20L", price: 7300, weight: "20.00 L" }
  ];

  const gearOilProducts = [
    { name: "BL HP 140 20X1L", price: 352, weight: "1.00 L" },
    { name: "BL HP 140 4X5L", price: 1675, weight: "5.00 L" },
    { name: "BL HP 140 10L", price: 3304, weight: "10.00 L" },
    { name: "BL HP 140 20L", price: 6535, weight: "20.00 L" },
    { name: "BL HP 80W90 20X1L", price: 361, weight: "1.00 L" },
    { name: "BL HP 80W90 4X5L", price: 1720, weight: "5.00 L" },
    { name: "BL HP 80W90 7L", price: 2530, weight: "7.00 L" },
    { name: "BL HP 80W90 10L", price: 3403, weight: "10.00 L" },
    { name: "BL HP 80W90 20L", price: 6760, weight: "20.00 L" },
    { name: "BL HP 90 20X0.5L", price: 172, weight: "0.50 L" },
    { name: "BL HP 90 20X1L", price: 334, weight: "1.00 L" },
    { name: "BL HP 90 20X1L (PROMO)", price: 334, weight: "1.00 L" },
    { name: "BL HP 90 4X5L", price: 1621, weight: "5.00 L" },
    { name: "BL HP 90 4X5L (PROMO)", price: 1621, weight: "5.00 L" },
    { name: "BL HP 90 10L", price: 3220, weight: "10.00 L" },
    { name: "BL HP 90 20L", price: 6400, weight: "20.00 L" },
    { name: "BL HP PLUS 85W140 20X1L", price: 370, weight: "1.00 L" },
    { name: "BL HP PLUS 85W140 4X5L", price: 1850, weight: "5.00 L" },
    { name: "BL HP PLUS 85W140 10L", price: 3800, weight: "10.00 L" },
    { name: "BL HP PLUS 85W140 12L", price: 4546, weight: "12.00 L" },
    { name: "BL HP PLUS 85W140 20L", price: 7003, weight: "20.00 L" }
  ];

  const hydraulicOilProducts = [
    { name: "BL CATMATSU HTX 68 4X5L", price: 1360, weight: "5.00 L" },
    { name: "BL CATMATSU HTX 68 20L", price: 5230, weight: "20.00 L" }
  ];

  const multigradeEngineOilProducts = [
    { name: "BL MAXIPULL SC3X 20W40 20X1.2L", price: 370, weight: "1.20 L" }
  ];

  const chemoleumGreaseProducts = [
    { name: "CHEMOLEUMS CRUSHER SPECIAL GREASE - 12X1KG", price: 297, weight: "1.00 KG", litrePrice: 297 },
    { name: "CHEMOLEUMS CRUSHER SPECIAL GREASE - 18 KG", price: 5999, weight: "18.00 KG", litrePrice: 333 },
    { name: "CHEMOLEUMS CRUSHER SPECIAL GREASE - 180 KG", price: 190, weight: "180.00 KG", litrePrice: 190 },
    { name: "CHEMOLEUMS CRUSHER SPECIAL GREASE - 2 X 5KG", price: 1499, weight: "5.00 KG", litrePrice: 300 },
    { name: "CHEMOLEUMS CRUSHER SPECIAL GREASE - 24X500GM", price: 189, weight: "0.50 KG", litrePrice: 378 },
    { name: "CHEMOLEUMS CRUSHER SPECIAL GREASE - 30 KG", price: 190, weight: "30.00 KG", litrePrice: 190 },
    { name: "CHEMOLEUMS CRUSHER SPECIAL GREASE - 4X3KG", price: 999, weight: "3.00 KG", litrePrice: 333 },
    { name: "CHEMOLEUMS CRUSHER SPECIAL GREASE - 6X2KG", price: 599, weight: "2.00 KG", litrePrice: 300 },
    { name: "CHEMOLEUMS EP 00 GREASE - 180", price: 305, weight: "180.00 KG", litrePrice: 305 },
    { name: "CHEMOLEUMS MARFAQ GOLDEN GEL GREASE - 24X500 GM", price: 225, weight: "0.50 KG", litrePrice: 450 },
    { name: "CHEMOLEUMS MARFAQ GOLDEN GEL GREASE - 10 KG", price: 5999, weight: "10.00 KG", litrePrice: 600 },
    { name: "CHEMOLEUMS MARFAQ GOLDEN GEL GREASE - 100X100 GM", price: 99, weight: "0.10 KG", litrePrice: 990 },
    { name: "CHEMOLEUMS MARFAQ GOLDEN GEL GREASE - 12X1 KG", price: 459, weight: "1.00 KG", litrePrice: 459 },
    { name: "CHEMOLEUMS MARFAQ GOLDEN GEL GREASE - 18 KG", price: 7999, weight: "18.00 KG", litrePrice: 444 },
    { name: "CHEMOLEUMS MARFAQ GOLDEN GEL GREASE - 180", price: 379, weight: "180.00 KG", litrePrice: 379 },
    { name: "CHEMOLEUMS MARFAQ GOLDEN GEL GREASE - 2X5 KG", price: 2259, weight: "5.00 KG", litrePrice: 452 },
    { name: "CHEMOLEUMS MARFAQ GOLDEN GEL GREASE - 4X3 KG", price: 1359, weight: "3.00 KG", litrePrice: 453 },
    { name: "CHEMOLEUMS MARFAQ GOLDEN GEL GREASE - 50X200 GM", price: 189, weight: "0.20 KG", litrePrice: 945 },
    { name: "CHEMOLEUMS MARFAQ GOLDEN GEL GREASE - 6X2 KG", price: 999, weight: "2.00 KG", litrePrice: 500 },
    { name: "CHEMOLEUMS MARFAQ GOLDEN GEL GREASE - 7 KG", price: 3699, weight: "7.00 KG", litrePrice: 528 },
    { name: "CHEMOLEUMS MARFAQ PREMIUM LONG LIFE GREASE - 10 KG", price: 4599, weight: "10.00 KG", litrePrice: 460 },
    { name: "CHEMOLEUMS MARFAQ PREMIUM LONG LIFE GREASE - 100 X 100GM", price: 69, weight: "0.10 KG", litrePrice: 690 },
    { name: "CHEMOLEUMS MARFAQ PREMIUM LONG LIFE GREASE - 12 X 1KG", price: 459, weight: "1.00 KG", litrePrice: 459 },
    { name: "CHEMOLEUMS MARFAQ PREMIUM LONG LIFE GREASE - 18 KG", price: 7779, weight: "18.00 KG", litrePrice: 433 },
    { name: "CHEMOLEUMS MARFAQ PREMIUM LONG LIFE GREASE - 180", price: 351, weight: "180.00 KG", litrePrice: 351 },
    { name: "CHEMOLEUMS MARFAQ PREMIUM LONG LIFE GREASE - 2 X 5KG", price: 1899, weight: "5.00 KG", litrePrice: 380 },
    { name: "CHEMOLEUMS MARFAQ PREMIUM LONG LIFE GREASE - 24 X 500GM", price: 225, weight: "0.50 KG", litrePrice: 450 },
    { name: "CHEMOLEUMS MARFAQ PREMIUM LONG LIFE GREASE - 4 X 3KG", price: 1269, weight: "3.00 KG", litrePrice: 423 },
    { name: "CHEMOLEUMS MARFAQ PREMIUM LONG LIFE GREASE - 50X200GM", price: 105, weight: "0.20 KG", litrePrice: 525 },
    { name: "CHEMOLEUMS MARFAQ PREMIUM LONG LIFE GREASE - 6 X 2KG", price: 999, weight: "2.00 KG", litrePrice: 500 },
    { name: "CHEMOLEUMS MARFAQ PREMIUM LONG LIFE GREASE - 7 KG", price: 3699, weight: "7.00 KG", litrePrice: 528 },
    { name: "CHEMOLEUMS MARFAQ RED GEL GREASE - 10 KG", price: 5999, weight: "10.00 KG", litrePrice: 600 },
    { name: "CHEMOLEUMS MARFAQ RED GEL GREASE - 100X100 GM", price: 99, weight: "0.10 KG", litrePrice: 990 },
    { name: "CHEMOLEUMS MARFAQ RED GEL GREASE - 12X1 KG", price: 459, weight: "1.00 KG", litrePrice: 459 },
    { name: "CHEMOLEUMS MARFAQ RED GEL GREASE - 18 KG", price: 7999, weight: "18.00 KG", litrePrice: 444 },
    { name: "CHEMOLEUMS MARFAQ RED GEL GREASE - 180", price: 379, weight: "180.00 KG", litrePrice: 379 },
    { name: "CHEMOLEUMS MARFAQ RED GEL GREASE - 18KG NP", price: 7999, weight: "18.00 KG", litrePrice: 444 },
    { name: "CHEMOLEUMS MARFAQ RED GEL GREASE - 24X500 GM", price: 225, weight: "0.50 KG", litrePrice: 450 },
    { name: "CHEMOLEUMS MARFAQ RED GEL GREASE - 2X5 KG", price: 2259, weight: "5.00 KG", litrePrice: 452 },
    { name: "CHEMOLEUMS MARFAQ RED GEL GREASE - 4X3 KG", price: 1359, weight: "3.00 KG", litrePrice: 453 },
    { name: "CHEMOLEUMS MARFAQ RED GEL GREASE - 50X200 GM", price: 189, weight: "0.20 KG", litrePrice: 945 },
    { name: "CHEMOLEUMS MARFAQ RED GEL GREASE - 6X2 KG", price: 999, weight: "2.00 KG", litrePrice: 500 },
    { name: "CHEMOLEUMS MARFAQ RED GEL GREASE - 7 KG", price: 3699, weight: "7.00 KG", litrePrice: 528 },
    { name: "CHEMOLEUMS MARFAQ S2 220 EP00 GREASE - 20KG", price: 8999, weight: "20.00 KG", litrePrice: 450 },
    { name: "EP 00 GREASE - 18 KG", price: 5199, weight: "18.00 KG", litrePrice: 289 },
    { name: "EP 00 GREASE - 20", price: 5499, weight: "20.00 KG", litrePrice: 275 },
    { name: "EP 000 GREASE - 18KG", price: 5499, weight: "18.00 KG", litrePrice: 306 },
    { name: "LITHEX EP2 GREASE - 180", price: 305, weight: "180.00 KG", litrePrice: 305 },
    { name: "LITHEX EP2 GREASE - 20", price: 8999, weight: "20.00 KG", litrePrice: 450 },
    { name: "LITHEX EP2 GREASE - 5X2", price: 2299, weight: "2.00 KG", litrePrice: 460 },
    { name: "LITHEX EP2 GREASE - 18 KG", price: 7999, weight: "18.00 KG", litrePrice: 459 },
    { name: "WHEEL BEARING GREASE - 18", price: 4899, weight: "18.00 KG", litrePrice: 272 },
    { name: "WHEEL BEARING GREASE - 180", price: 216, weight: "180.00 KG", litrePrice: 216 },
    { name: "WHEEL BEARING GREASE - 20", price: 5199, weight: "20.00 KG", litrePrice: 260 },
    { name: "WHEEL BEARING GREASE - 24X500GM", price: 189, weight: "0.50 KG", litrePrice: 378 }
];

const chemoleum2WProducts = [
  { name: "4T PLUS PREMIUM SAE 10W30-API SM - 12X1L NP", price: 405, weight: "1.00 L", litrePrice: 405 },
  { name: "4T PLUS PREMIUM SAE 10W30-API SM - 12X900ML NP", price: 385, weight: "0.90 L", litrePrice: 428 },
  { name: "4T PLUS PREMIUM SAE 10W30-API SM - 20X1L NP", price: 405, weight: "1.00 L", litrePrice: 405 },
  { name: "4T PLUS PREMIUM SAE 10W30-API SM - 20X900ML NP", price: 385, weight: "0.90 L", litrePrice: 428 },
  { name: "4T PLUS PREMIUM SAE 10W30-API SM - 210L", price: 204, weight: "210.00 L", litrePrice: 204 },
  { name: "4T PLUS PREMIUM SAE 10W-30-API SN-JASO MA2 - 12X1.2L NP", price: 788, weight: "1.20 L", litrePrice: 657 },
  { name: "4T PLUS PREMIUM SAE 10W-30-API SN-JASO MA2 - 12X1L NP", price: 689, weight: "1.00 L", litrePrice: 689 },
  { name: "4T PLUS PREMIUM SAE 10W-30-API SN-JASO MA2 - 20X1.2L NP", price: 788, weight: "1.20 L", litrePrice: 657 },
  { name: "4T PLUS PREMIUM SAE 10W-30-API SN-JASO MA2 - 20X1L NP", price: 689, weight: "1.00 L", litrePrice: 689 },
  { name: "4T PLUS PREMIUM SAE 20W-40 -API SM - 12X1L NP", price: 389, weight: "1.00 L", litrePrice: 389 },
  { name: "4T PLUS PREMIUM SAE 20W-40 -API SM - 12X1L PROMO", price: 405, weight: "1.00 L", litrePrice: 405 },
  { name: "4T PLUS PREMIUM SAE 20W-40 -API SM - 12X900ML NP", price: 375, weight: "0.90 L", litrePrice: 417 },
  { name: "4T PLUS PREMIUM SAE 20W-40 -API SM - 12X900ML PROMO", price: 379, weight: "0.90 L", litrePrice: 421 },
  { name: "4T PLUS PREMIUM SAE 20W-40 -API SM - 20X1L NP", price: 389, weight: "1.00 L", litrePrice: 389 },
  { name: "4T PLUS PREMIUM SAE 20W-40 -API SM - 20X1L PROMO", price: 405, weight: "1.00 L", litrePrice: 405 },
  { name: "4T PLUS PREMIUM SAE 20W-40 -API SM - 20X900ML NP", price: 375, weight: "0.90 L", litrePrice: 417 },
  { name: "4T PLUS PREMIUM SAE 20W-40 -API SM - 20X900ML PROMO", price: 379, weight: "0.90 L", litrePrice: 421 },
  { name: "4T PLUS PREMIUM SAE 20W-40 -API SM - 210", price: 204, weight: "210.00 L", litrePrice: 204 },
  { name: "4T PLUS PREMIUM SAE 20W40 -API SM - 55", price: 212, weight: "55.00 L", litrePrice: 212 },
  { name: "4T PREMIUM SAE 10W-30-API SN-JASO MB - 12X800ML", price: 459, weight: "0.80 L", litrePrice: 574 },
  { name: "4T PREMIUM SAE 10W-30-API SN-JASO MB - 12X800ML NP", price: 439, weight: "0.80 L", litrePrice: 549 },
  { name: "CHEM CHAIN LUBE SPRAY - 120 ML", price: 189, weight: "0.12 L", litrePrice: 1575 },
  { name: "CHEM CHAIN LUBE SPRAY - 24X120ML", price: 189, weight: "0.12 L", litrePrice: null }, // #VALUE! replaced with null
  { name: "ECO 4T PLUS SAE 20W 40 API-SL - 55 UDY", price: 202, weight: "55.00 L", litrePrice: 202 },
  { name: "ECO 4T PLUS SAE 20W40 (API-SL) - 12X900ML", price: 384, weight: "0.90 L", litrePrice: 427 },
  { name: "ECO 4T PLUS SAE 20W40 POUCH - 12X900ML", price: 360, weight: "0.90 L", litrePrice: 400 },
  { name: "ECO 4T PLUS SAE 20W40 (API-SL) - 12X1L", price: 414, weight: "1.00 L", litrePrice: 414 },
  { name: "ECO 4T PLUS SAE 20W40 (API-SL) - 26", price: 202, weight: "26.00 L", litrePrice: 202 },
  { name: "ECO 4T PLUS SAE 20W40 API SJ - 20X1L NP", price: 414, weight: "1.00 L", litrePrice: 414 },
  { name: "ECO 4T PLUS SAE 20W40 API SJ - 20X900ML NP", price: 384, weight: "0.90 L", litrePrice: 427 },
  { name: "ECO 4T PLUS SAE 20W40 API SL - 20X1L NP", price: 414, weight: "1.00 L", litrePrice: 414 },
  { name: "ECO 4T PLUS SAE 20W40 API SL - 20X1L NP(UDY)", price: 414, weight: "1.00 L", litrePrice: 414 },
  { name: "ECO 4T PLUS SAE 20W40 API SL - 20X1L PROMO", price: 414, weight: "1.00 L", litrePrice: 414 },
  { name: "ECO 4T PLUS SAE 20W40 API SL - 20X900ML", price: 384, weight: "0.90 L", litrePrice: 427 },
  { name: "ECO 4T PLUS SAE 20W40 API SL - 20X900ML NP", price: 384, weight: "0.90 L", litrePrice: 427 },
  { name: "ECO 4T PLUS SAE 20W40 API SL - 20X900ML NP(UDY)", price: 384, weight: "0.90 L", litrePrice: 427 },
  { name: "ECO 4T PLUS SAE 20W40 API SL - 20X900ML RS 25 COUPON", price: 384, weight: "0.90 L", litrePrice: 427 },
  { name: "ECO 4T PLUS SAE 20W40 API SL- 12X1 LTR NP", price: 414, weight: "1.00 L", litrePrice: 414 },
  { name: "ECO 4T PLUS SAE 20W40 API SL- 12X1L (RED) RS 25 COUPON", price: 414, weight: "1.00 L", litrePrice: 414 },
  { name: "ECO 4T PLUS SAE 20W40 API SL- 12X900 ML NP", price: 384, weight: "0.90 L", litrePrice: 427 },
  { name: "ECO 4T PLUS SAE 20W40 API SL- 12X900ML (RED) RS 25 COUPON", price: 384, weight: "0.90 L", litrePrice: 427 },
  { name: "ECO 4T PLUS SAE 20W40 API SL- 20X1L RS 25 COUPON", price: 414, weight: "1.00 L", litrePrice: 414 },
  { name: "ECO 4T PLUS SAE 20W40-API SL - 210", price: 195, weight: "210.00 L", litrePrice: 195 },
  { name: "ECO 4T PLUS SAE 20W-40-API SL - 55", price: 202, weight: "55.00 L", litrePrice: 202 },
  { name: "ECO 4T PREMIUM SAE 10W30 ( API SL) - 210", price: 195, weight: "210.00 L", litrePrice: 195 },
  { name: "ECO 4T PREMIUM SAE 10W-30-API SL - 12X1L PROMO", price: 379, weight: "1.00 L", litrePrice: 379 },
  { name: "ECO 4T PREMIUM SAE 10W-30-API SL - 12X900ML NP", price: 329, weight: "0.90 L", litrePrice: 366 },
  { name: "ECO 4T PREMIUM SAE 10W-30-API SL - 12X900ML PROMO", price: 329, weight: "0.90 L", litrePrice: 366 },
  { name: "ECO 4T PREMIUM SAE 10W-30-API SL - 20X1L", price: 379, weight: "1.00 L", litrePrice: 379 },
  { name: "ECO 4T PREMIUM SAE 10W-30-API SL - 20X1L NP", price: 379, weight: "1.00 L", litrePrice: 379 },
  { name: "ECO 4T PREMIUM SAE 10W-30-API SL - 20X900ML", price: 329, weight: "0.90 L", litrePrice: 366 },
  { name: "ECO 4T PREMIUM SAE 10W-30-API SL - 20X900ML NP", price: 329, weight: "0.90 L", litrePrice: 366 },
  { name: "ECO 4T PREMIUM SAE 10W-30-API SL - 55", price: 202, weight: "55.00 L", litrePrice: 202 },
  { name: "FRONT FORK OIL - 0.175x40", price: 99, weight: "0.18 L", litrePrice: 550 },
  { name: "FRONT FORK OIL - 0.350x20", price: 172, weight: "0.35 L", litrePrice: 491 },
  { name: "FRONT FORK OIL - 16X350ML", price: 172, weight: "0.35 L", litrePrice: 491 },
  { name: "MOTO GP 4T SAE 20W40 SN PROMO - 20X1L", price: 495, weight: "1.00 L", litrePrice: 495 },
  { name: "MOTO GP 4T SAE 20W40 SN PROMO - 20X900ML", price: 459, weight: "0.90 L", litrePrice: 510 },
  { name: "MOTO GP GRAND PRIX SAE 20W-50-API SN PROMO - 10X1.2L", price: 549, weight: "1.20 L", litrePrice: 458 },
  { name: "MOTO GP GRAND PRIX SAE 20W-50-API SN PROMO - 9X1.2L", price: 549, weight: "1.20 L", litrePrice: 458 },
  { name: "MOTO GP GRANDPRIX 4T SAE 20W50 API SN - 55", price: 197, weight: "55.00 L", litrePrice: 197 },
  { name: "MOTO GP GRANDPRIX 4T SAE 20W50 API-SN PROMO - 12x1L", price: 459, weight: "1.00 L", litrePrice: 459 },
  { name: "MOTO GP GRANDPRIX 4T SAE 20W50 API-SN PROMO - 20x1L", price: 459, weight: "1.00 L", litrePrice: 459 },
  { name: "MOTO GP GRANDPRIX 4T SAE 20W50 API-SN PROMO - 20x900ML", price: 429, weight: "0.90 L", litrePrice: 477 },
  { name: "MOTO GP GRANDPRIX 4T SAE 20W50 SN NP - 12x1L", price: 459, weight: "1.00 L", litrePrice: 459 },
  { name: "MOTO GP GRANDPRIX 4T SAE 20W50 SN NP - 12X900ML", price: 429, weight: "0.90 L", litrePrice: 477 },
  { name: "MOTO GP GRANDPRIX 4T SAE 20W50 SN NP - 20x1L", price: 459, weight: "1.00 L", litrePrice: 459 },
  { name: "MOTO GP GRANDPRIX 4T SAE 20W50 SN NP - 20x900ML", price: 429, weight: "0.90 L", litrePrice: 477 },
  { name: "OVER DRIVE 4T 20W40 APISN - 26 Ltr", price: 216, weight: "26.00 L", litrePrice: 216 },
  { name: "OVER DRIVE 4T 20W40 APISN - 55", price: 216, weight: "55.00 L", litrePrice: 216 },
  { name: "OVER DRIVE 4T SAE 20W40 - 12x1L NON PROMO", price: 468, weight: "1.00 L", litrePrice: 468 },
  { name: "OVER DRIVE 4T SAE 20W40 - 12x1L NP(UDY)", price: 468, weight: "1.00 L", litrePrice: 468 },
  { name: "OVER DRIVE 4T SAE 20W40 - 12x900ML NON PROMO", price: 439, weight: "0.90 L", litrePrice: 488 },
  { name: "OVER DRIVE 4T SAE 20W40 - 20X900ML NP", price: 439, weight: "0.90 L", litrePrice: 488 },
  { name: "OVER DRIVE 4T SAE 20W40 API-SN - 12X1", price: 488, weight: "1.00 L", litrePrice: 488 },
  { name: "OVER DRIVE 4T SAE 20W-40 (API-SN) - 12X900ML", price: 459, weight: "0.90 L", litrePrice: 510 },
  { name: "OVER DRIVE 4T SAE 20W-40 (API-SN) - 20X1L", price: 488, weight: "1.00 L", litrePrice: 488 },
  { name: "OVER DRIVE 4T SAE 20W-40 (API-SN) - 20X900ML", price: 459, weight: "0.90 L", litrePrice: 510 },
  { name: "OVER DRIVE 4T SAE 20W40 (API-SN) - 210", price: 208, weight: "210.00 L", litrePrice: 208 },
  { name: "OVER DRIVE 4T SAE 20W40 API SN - 20x1L NP", price: 468, weight: "1.00 L", litrePrice: 468 },
  { name: "RACING 1 4T 10W-40 API SN JASO MA2 - 12X1L RS 100 COUPON", price: 799, weight: "1.00 L", litrePrice: 799 },
  { name: "RACING 1 FULLY SYNTHETIC 10W40-API SN - 12X1L", price: 699, weight: "1.00 L", litrePrice: 699 },
  { name: "TOP SPEED SAE 15W50 ( API-SN) - 12X1L", price: 486, weight: "1.00 L", litrePrice: 486 },
  { name: "TOP SPEED SAE 15W50 (API SN) - 12X900ML", price: 459, weight: "0.90 L", litrePrice: 510 },
  { name: "TOP SPEED SAE 15W50 - 2.5X6", price: 999, weight: "2.50 L", litrePrice: 400 },
  { name: "TOP SPEED SAE 15W50 - 6X2.5L NP", price: 969, weight: "2.50 L", litrePrice: 388 },
  { name: "TOP SPEED SAE 15W50 (API-SN) - 12X1L NON PROMO", price: 414, weight: "1.00 L", litrePrice: 414 },
  { name: "TOP SPEED SAE 15W50 (API-SN) - 12X900ML NONPROMO", price: 376, weight: "0.90 L", litrePrice: 418 },
  { name: "TOP SPEED SAE 15W50 (API-SN) - 20X1L NP", price: 414, weight: "1.00 L", litrePrice: 414 },
  { name: "TOP SPEED SAE 15W50 (API-SN) - 20X900ML NP", price: 376, weight: "0.90 L", litrePrice: 418 },
  { name: "TOP SPEED SAE 15W50 API SN - 6 X 3 LTR", price: 1449, weight: "3.00 L", litrePrice: 483 },
  { name: "2T POWER API TC JASO FC - 12X1L", price: 338, weight: "1.00 L", litrePrice: 338 },
  { name: "2T POWER API TC JASO FC - 12X500ML", price: 149, weight: "0.50 L", litrePrice: 299 },
  { name: "2T POWER API TC JASO FC - 210", price: 230, weight: "210.00 L", litrePrice: 230 },
  { name: "2T POWER API TC JASO FC - 26", price: 183, weight: "26.00 L", litrePrice: 183 },
  { name: "2T POWER API TC JASO FC - 40X50ML", price: 22.5, weight: "0.05 L", litrePrice: 450 },
  { name: "2T POWER API TC JASO FC - 55", price: 279, weight: "55.00 L", litrePrice: 279 },
  { name: "2T POWER API TC JASO FC - 60X40ML", price: 8.55, weight: "0.04 L", litrePrice: 214 },
  { name: "2T POWER API TC JASO FC - 60X40ML(UDY)", price: 9.6, weight: "0.04 L", litrePrice: 240 },
  { name: "ECO 2T API TC JASO FB - 210", price: 195, weight: "210.00 L", litrePrice: 195 },
  { name: "ECO 2T API TC JASO FB - 26", price: 202, weight: "26.00 L", litrePrice: 202 },
  { name: "ECO 2T API TC JASO FB - 40X50ML", price: 10.1, weight: "0.05 L", litrePrice: 202 },
  { name: "ECO 2T API TC JASO FB - 55", price: 202, weight: "55.00 L", litrePrice: 202 },
  { name: "ECO 2T API TC JASO FB - 60X40ML", price: 8.1, weight: "0.04 L", litrePrice: 202 },
  { name: "ECO 2T API TC JASO FB - 60X40ML(UDY)", price: 7.32, weight: "0.04 L", litrePrice: 183 },
  { name: "ECO 2T POWER API TC JASO FB - 12X1L", price: 190, weight: "1.00 L", litrePrice: 190 },
  { name: "ECO 2T POWER API TC JASO FB - 12X500ML", price: 95, weight: "0.50 L", litrePrice: 190 },
  { name: "ECO 2T POWER API TC JASO FB - 26", price: 183, weight: "26.00 L", litrePrice: 183 },
  { name: "RACING 2T API TC JASO FD - 12X1L", price: 424, weight: "1.00 L", litrePrice: 424 },
  { name: "RACING 2T API TC JASO FD - 12X500ML", price: 202.5, weight: "0.50 L", litrePrice: 405 },
  { name: "RACING 2T API TC JASO FD - 26", price: 424, weight: "26.00 L", litrePrice: 424 },
  { name: "RACING 2T API TC JASO FD - 40X50ML", price: 9.75, weight: "0.05 L", litrePrice: 195 },
  { name: "RACING 2T API TC JASO FD - 55", price: 208, weight: "55.00 L", litrePrice: 208 },
  { name: "RACING 2T API TC JASO FD - 60X40ML", price: 8.55, weight: "0.04 L", litrePrice: 214 },
  { name: "RACING 2T API TC JASO FD - 60X40ML(UDY)", price: 17.28, weight: "0.04 L", litrePrice: 432 },
  { name: "RACING 2T JASO FD API TC - 210", price: 190, weight: "210.00 L", litrePrice: 190 },
  { name: "RACING 2T JASO FD API TC - 40X50ML(UDY)", price: 9.75, weight: "0.05 L", litrePrice: 195 },
  { name: "RACING 2T JASO FD API TC - 60X40ML(UDY)", price: 7.8, weight: "0.04 L", litrePrice: 195 },
  { name: "RACING 2T JASO FD API TC(UDY) - 12X1L", price: 405, weight: "1.00 L", litrePrice: 405 },
  { name: "RACING 2T JASaO FD API TC(UDY) - 12X500ML", price: 202.5, weight: "0.50 L", litrePrice: 405 },
  { name: "RACING 2T JASO FD API TC(UDY) - 26", price: 405, weight: "26.00 L", litrePrice: 405 },
  { name: "RACING 2T JASO FD API TC(UDY) - 40X50ML", price: 202.5, weight: "0.05 L", litrePrice: 405 },
  { name: "RACING 2T JASO FD API TC(UDY) - 55", price: 432, weight: "55.00 L", litrePrice: 432 },
  { name: "RACING 2T JASO FD API TC(UDY) - 60X40ML", price: 9.2, weight: "0.04 L", litrePrice: 230 },
  { name: "TOP 2T API TC JASO FC - 12X1L", price: 418, weight: "1.00 L", litrePrice: 418 },
  { name: "TOP 2T API TC JASO FC - 12X500ML", price: 97.5, weight: "0.50 L", litrePrice: 195 },
  { name: "TOP 2T API TC JASO FC - 210", price: 432, weight: "210.00 L", litrePrice: 432 },
  { name: "TOP 2T API TC JASO FC - 26", price: 432, weight: "26.00 L", litrePrice: 432 },
  { name: "TOP 2T API TC JASO FC - 40X50ML", price: 21.6, weight: "0.05 L", litrePrice: 432 },
  { name: "TOP 2T API TC JASO FC - 55", price: 195, weight: "55.00 L", litrePrice: 195 },
  { name: "TOP 2T API TC JASO FC - 60X40ML", price: 25.5, weight: "0.04 L", litrePrice: 510 },
  { name: "TOP 2T API TC JASO FC - 60X40ML(UDY)", price: 8.32, weight: "0.04 L", litrePrice: 208 },
  { name: "TOP 2T API TC JASO FC(UDY) - 12X1L", price: 8.55, weight: "1.00 L", litrePrice: 214 },
  { name: "TOP 2T API TC JASO FC(UDY) - 12X500ML", price: 243, weight: "0.50 L", litrePrice: 486 },
  { name: "TOP 2T API TC JASO FC(UDY) - 40X50ML", price: 10.4, weight: "0.05 L", litrePrice: 208 },
  { name: "TOP 2T API TC JASO FC(UDY) - 60X40ML", price: 8.55, weight: "0.04 L", litrePrice: 214 }
];


const chemoleum3WProducts = [
  { name: "3W AUTO RIDER LIFE 20W50 JASO MA2/SL - 20X1L", price: 369, weight: "1.00 L", litrePrice: 0 },
  { name: "3W AUTO RIDER LIFE 20W50 JASO MA2/SL - 20X500ML", price: 169, weight: "0.50 L", litrePrice: 338 },
  { name: "3W AUTO RIDER LIFE SAE 15W-40-API CH4/SL - 6X3L", price: 999, weight: "3.00 L", litrePrice: 333 },
  { name: "3W AUTO RIDER LIFE SAE 20W-50-JASO MA2/API SL - 9X2.1L", price: 799, weight: "2.10 L", litrePrice: 380 },
  { name: "3W CNG POWER SAE 20W50 - 11 NP", price: 2889, weight: "11.00 L", litrePrice: 263 },
  { name: "3W CNG POWER SAE 20W50 - 26 Ltr", price: 190, weight: "26.00 L", litrePrice: 190 },
  { name: "3W CNG POWER SAE 20W50 - 55", price: 190, weight: "55.00 L", litrePrice: 190 },
  { name: "3W CNG POWER SAE 20W50 (UDY)- 1x20", price: 349, weight: "1.00 L", litrePrice: 349 },
  { name: "3W TURBO GEO CNG 20W-50 - 4X4.5L", price: 1350, weight: "4.50 L", litrePrice: 300 },
  { name: "3W TURBO CNG POWER SAE 20W50 - 12X1L UDY", price: 349, weight: "1.00 L", litrePrice: 349 },
  { name: "3W TURBO CNG POWER SAE 20W50 (POUCH) - 12x1 LTR", price: 339, weight: "1.00 L", litrePrice: 339 },
  { name: "3W TURBO CNG POWER SAE 20W50 API SG/CF - 20x1L", price: 349, weight: "1.00 L", litrePrice: 349 },
  { name: "3W TURBO CNG SAE 20W50-API SG/CF - 12X1L", price: 349, weight: "1.00 L", litrePrice: 349 },
  { name: "3W TURBO CNG SAE 20W50-API SG/CF - 20X500ML", price: 159, weight: "0.50 L", litrePrice: 318 },
  { name: "3W TURBO GEO CNG 20W50 - 0.5x20", price: 159, weight: "0.50 L", litrePrice: 318 },
  { name: "3W TURBO GEO CNG 20W50 API SL - 20X1L", price: 349, weight: "1.00 L", litrePrice: 349 },
  { name: "3W TURBO GEO SAE 20W50 UDY - 210", price: 183, weight: "210.00 L", litrePrice: 183 },
  { name: "3W TURBO GEO SAE 20W50 UDY - 55", price: 190, weight: "55.00 L", litrePrice: 190 },
  { name: "3W TURBO GEO SAE 20W50 UDY - 0.5x20", price: 159, weight: "0.50 L", litrePrice: 318 },
  { name: "3W TURBO GEO SAE 20W50 UDY - 1x20", price: 349, weight: "1.00 L", litrePrice: 349 },
  { name: "3W TURBO GEO SAE 20W50 UDY - 3x6", price: 999, weight: "3.00 L", litrePrice: 333 },
  { name: "3W TURBO MAX SUPER 15W40 - 15 LTR", price: 4535, weight: "15.00 L", litrePrice: 302 },
  { name: "3W TURBO MAX SUPER 15W40 - 210", price: 195, weight: "210.00 L", litrePrice: 195 },
  { name: "3W TURBO MAX SUPER 15W40 - 210 (GD)", price: 195, weight: "210.00 L", litrePrice: 195 },
  { name: "3W TURBO MAX SUPER 15W40 - 55", price: 202, weight: "55.00 L", litrePrice: 202 },
  { name: "3W TURBO MAX SUPER 15W40 - 55 (GD)", price: 202, weight: "55.00 L", litrePrice: 202 },
  { name: "3W TURBO MAX SUPER 15W40 CH4 - 10", price: 3499, weight: "10.00 L", litrePrice: 350 },
  { name: "3W TURBO MAX SUPER 15W40 CH4 - 10 NP", price: 3199, weight: "10.00 L", litrePrice: 320 },
  { name: "3W TURBO MAX SUPER 15W40 CH4 - 26", price: 202, weight: "26.00 L", litrePrice: 202 },
  { name: "3W TURBO MAX SUPER SAE 15W40 - 12X1L", price: 339, weight: "1.00 L", litrePrice: 339 },
  { name: "3W TURBO MAX SUPER SAE 15W40 - 20X1L", price: 339, weight: "1.00 L", litrePrice: 339 },
  { name: "3W TURBO MAX SUPER SAE 15W40 - 20X500ML", price: 178, weight: "0.50 L", litrePrice: 356 },
  { name: "3W TURBO MAX SUPER SAE 15W40 - 26 (GD)", price: 202, weight: "26.00 L", litrePrice: 202 },
  { name: "3W TURBO MAX SUPER SAE 15W40 API CH4 - 20X1L PROMO", price: 387, weight: "1.00 L", litrePrice: 387 },
  { name: "3W TURBO MAX SUPER SAE 15W40 API CH4 - 2X6L", price: 1950, weight: "6.00 L", litrePrice: 325 },
  { name: "3W TURBO MAX SUPER SAE 15W40 API CH4 - 2X6L NP", price: 1699, weight: "6.00 L", litrePrice: 283 },
  { name: "3W TURBO MAX SUPER SAE 15W40 API CH4 - 2X7.5L", price: 2599, weight: "7.50 L", litrePrice: 347 },
  { name: "3W TURBO MAX SUPER SAE 15W40 API CH4 - 2X7.5L NP", price: 2499, weight: "7.50 L", litrePrice: 333 },
  { name: "3W TURBO MAX SUPER SAE 15W40 API CH4 - 6X3 LTR", price: 1239, weight: "3.00 L", litrePrice: 413 },
  { name: "3W TURBO MAX SUPER SAE 15W40 API CH4 - 6X3 LTR RS 100", price: 1269, weight: "3.00 L", litrePrice: 423 },
  { name: "3W TURBO MAX SUPER SAE 15W40 CH4 - 5X4", price: 1699, weight: "5.00 L", litrePrice: 340 },
  { name: "3W TURBO MAX SUPER SAE 15W-40-API CH4 - 17", price: 5250, weight: "17.00 L", litrePrice: 309 },
  { name: "3W TURBO MAX SUPER SAE 15W-40-API CH4 - 2X7L", price: 2399, weight: "7.00 L", litrePrice: 343 },
  { name: "3W TURBO MAX SUPER SAE 15W-40-API CH4 - 2X7L RS 25 POINT", price: 2259, weight: "7.00 L", litrePrice: 323 },
  { name: "3W TURBO MAX SUPER SAE 15W-40-API CH4 - 6X3L NP", price: 1150, weight: "3.00 L", litrePrice: 383 },
  { name: "3W TURBO MAX SUPER SAE 15W-40-API CH4--PROMO-12X1", price: 387, weight: "1.00 L", litrePrice: 387 },
  { name: "3W TURBO POWER 15W40 - 0.500X20", price: 169, weight: "0.50 L", litrePrice: 338 },
  { name: "3W TURBO POWER 15W40 - 12X1", price: 299, weight: "1.00 L", litrePrice: 299 },
  { name: "3W TURBO POWER 15W40 - 1X20", price: 299, weight: "1.00 L", litrePrice: 299 },
  { name: "3W TURBO POWER 15W40 - 3X6", price: 889, weight: "3.00 L", litrePrice: 296 },
  { name: "3W TURBO POWER 15W40 NP - 2.5x6", price: 869, weight: "2.50 L", litrePrice: 348 },
  { name: "3W TURBO POWER 15W40 NP - 3X6", price: 889, weight: "3.00 L", litrePrice: 296 },
  { name: "3W TURBO POWER PLUS 15W-40 - 12X1", price: 324, weight: "1.00 L", litrePrice: 324 },
  { name: "3W TURBO POWER PLUS SAE 15W40 - 0.5", price: 159, weight: "0.50 L", litrePrice: 318 },
  { name: "3W TURBO POWER PLUS SAE 15W40 - 3x6", price: 999, weight: "3.00 L", litrePrice: 333 },
  { name: "3W TURBO POWER PLUS SAE 15W40 - 6x3L NP", price: 899, weight: "3.00 L", litrePrice: 300 },
  { name: "3W TURBO POWER SAE 15W40 - 10 NP", price: 2999, weight: "10.00 L", litrePrice: 300 },
  { name: "3W TURBO POWER SAE 15W-40 API CF4 - 6X2L", price: 799, weight: "2.00 L", litrePrice: 400 },
  { name: "3W TURBO POWER SAE 15W40 API-CF4 - 2X7.5L NP", price: 3599, weight: "7.50 L", litrePrice: 480 },
  { name: "3W TURBO POWER SAE 15W40 API-CF4 - 6X3 LTR", price: 999, weight: "3.00 L", litrePrice: 333 },
  { name: "3W TURBO POWER SAE 15W40 API-CF4 - 8.5L", price: 2399, weight: "8.50 L", litrePrice: 282 },
  { name: "3W TURBO POWER SAE 15W40 API-CH4 - 3X6", price: 999, weight: "3.00 L", litrePrice: 333 },
  { name: "3W TURBO POWER SAE 15W-40 API-CH4 - 6X2.5L RS.100", price: 799, weight: "2.50 L", litrePrice: 320 },
  { name: "3W TURBO POWER SAE 15W-40 API-CH4-0.500X20", price: 169, weight: "0.50 L", litrePrice: 338 },
  { name: "3W TURBO POWER SAE 15W-40 API-CH4-2.5X6", price: 799, weight: "2.50 L", litrePrice: 320 },
  { name: "3W TURBO POWER SAE 15W-40-API CF4 - 2X7L NP", price: 2359, weight: "7.00 L", litrePrice: 337 },
  { name: "3W TURBO POWER SAE 15W-40-API CF4 - 6X2.5L", price: 799, weight: "2.50 L", litrePrice: 320 },
  { name: "3W TURBO POWER SAE 15W40-API CH4 - 6X2L", price: 599, weight: "2.00 L", litrePrice: 300 },
  { name: "3W TURBO POWER SAE 15W40-API CH4 - 6X3L NP", price: 999, weight: "3.00 L", litrePrice: 333 },
  { name: "3W TURBO POWER SAE 15W-40-API CH4-12X1", price: 299, weight: "1.00 L", litrePrice: 299 }
];
const chemoleumPCMOProducts = [
  { name: "4T SAE 5W-30-SYNTHETIC-APISN - 210", price: 229, weight: "210.00 L", litrePrice: 229 },
  { name: "CHEM FULLY SYNTHETIC API SN/CF SAE 10W40 - 210", price: 229, weight: "210.00 L", litrePrice: 229 },
  { name: "CHEM FULLY SYNTHETIC API SN/CF SAE 10W40 - 4X3.5L", price: 1950, weight: "3.50 L", litrePrice: 557 },
  { name: "CHEM FULLY SYNTHETIC API SN/CF SAE 10W40 - 4X3.5L NP", price: 1905, weight: "3.50 L", litrePrice: 544 },
  { name: "CHEM FULLY SYNTHETIC API SN/CF SAE 10W40 - 55", price: 232, weight: "55.00 L", litrePrice: 232 },
  { name: "CHEM FULLY SYNTHETIC API SN/CF SAE 5W30 - 4X4.5L", price: 3399, weight: "4.50 L", litrePrice: 755 },
  { name: "CHEM FULLY SYNTHETIC API SN/CF SAE 5W30 - 4X4.5L NP", price: 2799, weight: "4.50 L", litrePrice: 622 },
  { name: "CHEM FULLY SYNTHETIC SCREW COMPRESSOR OIL - 20", price: 12699, weight: "20.00 L", litrePrice: 635 },
  { name: "CHEM FULLY SYNTHETIC SCREW COMPRESSOR OIL - 210", price: 391, weight: "210.00 L", litrePrice: 391 },
  { name: "CHEM FULLY SYNTHETIC SCREW COMPRESSOR OIL - 4X5L", price: 3599, weight: "5.00 L", litrePrice: 720 },
  { name: "CHEM FULLY SYNTHETIC SCREW COMPRESSOR OIL - 55", price: 391, weight: "55.00 L", litrePrice: 391 },
  { name: "CHEMSYNTH SYNTHETIC 10W-40-API SN /CF - 26", price: 277, weight: "26.00 L", litrePrice: 277 },
  { name: "ECO CLEAN 5W-30 API SN Semi Synthetic - 210", price: 202, weight: "210.00 L", litrePrice: 202 },
  { name: "ECO CLEAN SAE 5W-30 API SN - 20X1L NP", price: 279, weight: "1.00 L", litrePrice: 279 },
  { name: "ECO CLEAN SAE 5W30 API SN - 55", price: 208, weight: "55.00 L", litrePrice: 208 },
  { name: "ECO CLEAN SAE 5W-30-API SN - 3.5X4", price: 1599, weight: "3.50 L", litrePrice: 457 },
  { name: "ECO CLEAN SAE 5W-30-API SN - 3.5X4 NON PROMO", price: 1599, weight: "3.50 L", litrePrice: 457 },
  { name: "ECO CLEAN SAE 5W-30-API SN - 4X4L", price: 2228, weight: "4.00 L", litrePrice: 557 },
  { name: "ECO CLEAN SAE 5W-30-API SN - 4X4L NP", price: 2005, weight: "4.00 L", litrePrice: 501 },
  { name: "ECO CLEAN SAE 5W-30-API SN - 4X5L", price: 2399, weight: "5.00 L", litrePrice: 480 },
  { name: "ECO CLEAN SAE 5W-30-API SN SYNTHETIC TECHNOLOGY - 6X3L NP", price: 1350, weight: "3.00 L", litrePrice: 450 },
  { name: "ECO CLEAN SAE 5W-30-API SN SYNTHETIC TECHNOLOGY - 6X3L PROMO", price: 1350, weight: "3.00 L", litrePrice: 450 },
  { name: "FULLY SYNTHETIC MOTOR OIL SAE 5W40 - 12X1L", price: 1159, weight: "1.00 L", litrePrice: 1159 },
  { name: "FULLY SYNTHETIC MOTOR OIL SAE 5W40 - 1X20", price: 1159, weight: "1.00 L", litrePrice: 1159 },
  { name: "HYSPEED SAE 10W30 - 210", price: 208, weight: "210.00 L", litrePrice: 208 },
  { name: "HYSPEED SAE 10W30 - 3.5X4", price: 1150, weight: "3.50 L", litrePrice: 329 },
  { name: "HYSPEED SAE 10W30 - 55", price: 214, weight: "55.00 L", litrePrice: 214 },
  { name: "POLARIS 1120 SYN MOTOR OIL SAE 5W40 - 210", price: 278, weight: "210.00 L", litrePrice: 278 },
  { name: "POLARIS 1120 SYN MOTOR OIL SAE 5W40 - 26", price: 281, weight: "26.00 L", litrePrice: 281 },
  { name: "POLARIS 1120 SYN MOTOR OIL SAE 5W40 - 4X3.5L", price: 4399, weight: "3.50 L", litrePrice: 1257 },
  { name: "POLARIS 1120 SYN MOTOR OIL SAE 5W40 - 4X4L", price: 4689, weight: "4.00 L", litrePrice: 1172 },
  { name: "POLARIS 1120 SYN MOTOR OIL SAE 5W40 - 4X4L NP", price: 4689, weight: "4.00 L", litrePrice: 1172 },
  { name: "POLARIS 1120 SYN MOTOR OIL SAE 5W40 - 55 LTR", price: 281, weight: "55.00 L", litrePrice: 281 },
  { name: "SUPREME ENERGY SAE 20W50 - 3.5X4", price: 999, weight: "3.50 L", litrePrice: 285 },
  { name: "SUPREME ENERGY SAE 20W50 - 55", price: 195, weight: "55.00 L", litrePrice: 195 },
  { name: "SUPREME SG 20W50 - 26", price: 183, weight: "26.00 L", litrePrice: 183 },
  { name: "SUPREME SG SAE 20W50 - 210", price: 180, weight: "210.00 L", litrePrice: 180 },
  { name: "SUPREME SG SAE 20W50 - 55", price: 183, weight: "55.00 L", litrePrice: 183 },
  { name: "SUPREME SG SAE 20W-50 UDY-210", price: 180, weight: "210.00 L", litrePrice: 180 },
  { name: "SUPREME UNIVERSAL 20W50 - 210", price: 180, weight: "210.00 L", litrePrice: 180 },
  { name: "SUPREME UNIVERSAL 20W50 - 55", price: 183, weight: "55.00 L", litrePrice: 183 },
  { name: "SUPREME UNIVERSAL 20W50 - 6X3L", price: 925, weight: "3.00 L", litrePrice: 308 },
  { name: "SUPREME UNIVERSAL 20W50 SL - 20X1L", price: 309, weight: "1.00 L", litrePrice: 309 },
  { name: "SUPREME UNIVERSAL SAE 20W50 - 26", price: 183, weight: "26.00 L", litrePrice: 183 },
  { name: "SUPREME UNIVERSAL SAE 20W50 API-SL - 12 X 1", price: 309, weight: "1.00 L", litrePrice: 309 },
  { name: "SUPREME UNIVERSAL SAE 20W50-APISL - 6X3L NP", price: 925, weight: "3.00 L", litrePrice: 308 },
  { name: "TURBO G1 SYNTHETIC SAE 5W30 - 12X1L", price: 529, weight: "1.00 L", litrePrice: 529 },
  { name: "TURBO G1 SYNTHETIC SAE 5W30 - 20X1L", price: 529, weight: "1.00 L", litrePrice: 529 },
  { name: "TURBO G1 SYNTHETIC SAE 5W30 - 210", price: 256, weight: "210.00 L", litrePrice: 256 },
  { name: "TURBO G1 SYNTHETIC SAE 5W30 - 26", price: 265, weight: "26.00 L", litrePrice: 265 },
  { name: "TURBO G1 SYNTHETIC SAE 5W30 - 2X7L", price: 3599, weight: "7.00 L", litrePrice: 514 },
  { name: "TURBO G1 SYNTHETIC SAE 5W30 - 3.5X4", price: 1999, weight: "3.50 L", litrePrice: 571 },
  { name: "TURBO G1 SYNTHETIC SAE 5W30 - 3.5X4 NP", price: 1899, weight: "3.50 L", litrePrice: 543 },
  { name: "TURBO G1 SYNTHETIC SAE 5W30 - 3X4 NON PROMO", price: 1599, weight: "3.00 L", litrePrice: 533 },
  { name: "TURBO G1 SYNTHETIC SAE 5W30 - 4X3L", price: 1599, weight: "3.00 L", litrePrice: 533 },
  { name: "TURBO G1 SYNTHETIC SAE 5W30 - 4X4L", price: 2799, weight: "4.00 L", litrePrice: 700 },
  { name: "TURBO G1 SYNTHETIC SAE 5W30 - 4X5L", price: 3299, weight: "5.00 L", litrePrice: 660 },
  { name: "TURBO G1 SYNTHETIC SAE 5W30 - 55", price: 265, weight: "55.00 L", litrePrice: 265 },
  { name: "TURBO G1 SYNTHETIC SAE 5W30 - 6X3L NP", price: 1599, weight: "3.00 L", litrePrice: 533 },
  { name: "TURBO SEMI SYNTHETIC SAE 10W40 - 26", price: 228, weight: "26.00 L", litrePrice: 228 },
  { name: "TURBO ULTRA SEMI SYNTHETIC 10W30 - 210", price: 204, weight: "210.00 L", litrePrice: 204 }
];
 const chemoleumGearXmissionProducts = [
    { name: "CHEMOLEUMS ATF DEXRON III - 210", price: 229, weight: "210.00 L", litrePrice: 229 },
    { name: "TQA GEAR OIL - 0.500x20", price: 178, weight: "0.50 L", litrePrice: 356 },
    { name: "TQA GEAR OIL - 12X1", price: 349, weight: "1.00 L", litrePrice: 349 },
    { name: "TQA GEAR OIL - 20", price: 4500, weight: "20.00 L", litrePrice: 225 },
    { name: "TQA GEAR OIL - 210", price: 180, weight: "210.00 L", litrePrice: 180 },
    { name: "TQA GEAR OIL - 55", price: 183, weight: "55.00 L", litrePrice: 183 },
    { name: "TQA GEAR OIL - 15", price: 3500, weight: "15.00 L", litrePrice: 233 },
    { name: "TQA GEAR OIL - 1x20", price: 349, weight: "1.00 L", litrePrice: 349 },
    { name: "TQA GEAR OIL - 5X4", price: 1699, weight: "5.00 L", litrePrice: 340 },
    { name: "TQA GEAR OIL - 6X3", price: 799, weight: "3.00 L", litrePrice: 266 },
    { name: "TQA GEAR OIL-26 LTR", price: 195, weight: "26.00 L", litrePrice: 195 },
    { name: "TURBO GL4 SAE 140 - 10", price: 2599, weight: "10.00 L", litrePrice: 260 },
    { name: "TURBO GL4 SAE 140 - 12", price: 3399, weight: "12.00 L", litrePrice: 283 },
    { name: "TURBO GL4 SAE 140 - 12X1", price: 324, weight: "1.00 L", litrePrice: 324 },
    { name: "TURBO GL4 SAE 140 - 20", price: 4599, weight: "20.00 L", litrePrice: 230 },
    { name: "TURBO GL4 SAE 140 - 20X1", price: 324, weight: "1.00 L", litrePrice: 324 },
    { name: "TURBO GL4 SAE 140 - 210", price: 195, weight: "210.00 L", litrePrice: 195 },
    { name: "TURBO GL4 SAE 140 - 2X7L", price: 1950, weight: "7.00 L", litrePrice: 279 },
    { name: "TURBO GL4 SAE 140 - 0.500X20", price: 159, weight: "0.50 L", litrePrice: 318 },
    { name: "TURBO GL4 SAE 140 - 20 NP", price: 4499, weight: "20.00 L", litrePrice: 225 },
    { name: "TURBO GL4 SAE 140 - 26 LTR", price: 202, weight: "26.00 L", litrePrice: 202 },
    { name: "TURBO GL4 SAE 140 - 4X5L NP", price: 1699, weight: "5.00 L", litrePrice: 340 },
    { name: "TURBO GL4 SAE 140 - 55", price: 202, weight: "55.00 L", litrePrice: 202 },
    { name: "TURBO GL4 SAEA 140 - 5X4", price: 1699, weight: "5.00 L", litrePrice: 340 },
    { name: "TURBO GL4 SAE 75W-90 FULLY SYNTHETIC GEAR OIL - 12X1 LTR", price: 459, weight: "1.00 L", litrePrice: 459 },
    { name: "TURBO GL4 SAE 75W-90 FULLY SYNTHETIC GEAR OIL - 20X1L", price: 459, weight: "1.00 L", litrePrice: 459 },
    { name: "TURBO GL4 SAE 75W-90 FULLY SYNTHETIC GEAR OIL - 210", price: 232, weight: "210.00 L", litrePrice: 232 },
    { name: "TURBO GL4 SAE 75W-90 FULLY SYNTHETIC GEAR OIL - 26", price: 242, weight: "26.00 L", litrePrice: 242 },
    { name: "TURBO GL4 SAE 75W-90 FULLY SYNTHETIC GEAR OIL - 55", price: 236, weight: "55.00 L", litrePrice: 236 },
    { name: "TURBO GL4 SAE 75W90 FULLY SYNTHETIC GEAR OIL - 6X2.5 LTR", price: 1350, weight: "2.50 L", litrePrice: 540 },
    { name: "TURBO GL4 SAE 80W 90 - 3x6", price: 822, weight: "3.00 L", litrePrice: 274 },
    { name: "TURBO GL4 SAE 80W90 - 10 NP", price: 2689, weight: "10.00 L", litrePrice: 269 },
    { name: "TURBO GL4 SAE 80W90 - 12 NP", price: 3399, weight: "12.00 L", litrePrice: 283 },
    { name: "TURBO GL4 SAE 80W90 - 1X20", price: 324, weight: "1.00 L", litrePrice: 324 },
    { name: "TURBO GL4 SAE 80W90 - 2.5X6", price: 799, weight: "2.50 L", litrePrice: 320 },
    { name: "TURBO GL4 SAE 80W90 - 20", price: 6059, weight: "20.00 L", litrePrice: 303 },
    { name: "TURBO GL4 SAE 80W90 - 210", price: 193, weight: "210.00 L", litrePrice: 193 },
    { name: "TURBO GL4 SAE 80W90 - 2X6", price: 599, weight: "2.00 L", litrePrice: 300 },
    { name: "TURBO GL4 SAE 80W90 - 5X4", price: 1599, weight: "5.00 L", litrePrice: 320 },
    { name: "TURBO GL4 SAE 80W90 - 5X4 NP", price: 1599, weight: "5.00 L", litrePrice: 320 },
    { name: "TURBO GL4 SAE 80W90 - 9X2L", price: 599, weight: "2.00 L", litrePrice: 300 },
    { name: "TURBO GL4 SAE 80W-90 - 12X1", price: 324, weight: "1.00 L", litrePrice: 324 },
    { name: "TURBO GL4 SAE 80W-90 - 26 Ltr", price: 202, weight: "26.00 L", litrePrice: 202 },
    { name: "TURBO GL4 SAE 80W90 - 26LTR", price: 202, weight: "26.00 L", litrePrice: 202 },
    { name: "TURBO GL4 SAE 80W90 - 2X7 LTR", price: 1899, weight: "7.00 L", litrePrice: 271 },
    { name: "TURBO GL4 SAE 80W-90 - 2X7.5", price: 1950, weight: "7.50 L", litrePrice: 260 },
    { name: "TURBO GL4 SAE 80W-90 - 3X6", price: 889, weight: "3.00 L", litrePrice: 296 },
    { name: "TURBO GL4 SAE 80W-90 - 55", price: 202, weight: "55.00 L", litrePrice: 202 },
    { name: "TURBO GL4 SAE 90 - 0.500X20", price: 151, weight: "0.50 L", litrePrice: 302 },
    { name: "TURBO GL4 SAE 90 - 12X1", price: 322, weight: "1.00 L", litrePrice: 322 },
    { name: "TURBO GL4 SAE 90 - 1X20", price: 322, weight: "1.00 L", litrePrice: 322 },
    { name: "TURBO GL4 SAE 90 - 210", price: 180, weight: "210.00 L", litrePrice: 180 },
    { name: "TURBO GL4 SAE 90 - 2X7L", price: 1950, weight: "7.00 L", litrePrice: 279 },
    { name: "TURBO GL4 SAE 90 - 4X5L NP", price: 1699, weight: "5.00 L", litrePrice: 340 },
    { name: "TURBO GL4 SAE 90 - 5X4", price: 1699, weight: "5.00 L", litrePrice: 340 },
    { name: "TURBO GL4 SAE 90 - 20", price: 5499, weight: "20.00 L", litrePrice: 275 },
    { name: "TURBO GL4 SAE 90 - 26 LTR", price: 190, weight: "26.00 L", litrePrice: 190 },
    { name: "TURBO GL4 SAE 90 - 55", price: 190, weight: "55.00 L", litrePrice: 190 },
    { name: "TURBO GL4 SAE 90 - 5X4 NP", price: 1699, weight: "5.00 L", litrePrice: 340 },
    { name: "TURBO GL4 SAE 90 -12X1 (POUCH)", price: 333, weight: "1.00 L", litrePrice: 333 },
    { name: "TURBO GL5 SAE 75W-90 FULLY SYNTHETIC GEAR OIL - 210", price: 242, weight: "210.00 L", litrePrice: 242 },
    { name: "TURBO GL5 SAE 75W-90 FULLY SYNTHETIC GEAR OIL - 55", price: 244, weight: "55.00 L", litrePrice: 244 },
    { name: "TURBO GL5 SAE 80W90 - 210", price: 193, weight: "210.00 L", litrePrice: 193 },
    { name: "TURBO GL5 SAE 85W140 - 12", price: 3588, weight: "12.00 L", litrePrice: 299 },
    { name: "TURBO GL5 SAE 85W140 - 12X1", price: 339, weight: "1.00 L", litrePrice: 339 },
    { name: "TURBO GL5 SAE 85W140 - 1X20", price: 339, weight: "1.00 L", litrePrice: 339 },
    { name: "TURBO GL5 SAE 85W140 - 20", price: 6399, weight: "20.00 L", litrePrice: 320 },
    { name: "TURBO GL5 SAE 85W140 - 210", price: 216, weight: "210.00 L", litrePrice: 216 },
    { name: "TURBO GL5 SAE 85W-140 - 10", price: 3399, weight: "10.00 L", litrePrice: 340 },
    { name: "TURBO GL5 SAE 85W-140 - 26 Ltr", price: 228, weight: "26.00 L", litrePrice: 228 },
    { name: "TURBO GL5 SAE 85W-140 - 55", price: 228, weight: "55.00 L", litrePrice: 228 },
    { name: "TURBO GL5 SAE 85W140 - 5X4", price: 1599, weight: "5.00 L", litrePrice: 320 },
    { name: "TURBO GL5 SAE 85W140 - 5X4 NP", price: 1599, weight: "5.00 L", litrePrice: 320 },
    { name: "TURBO GL5 SAE 85W-140-15LTR", price: 4575, weight: "15.00 L", litrePrice: 305 }
];
const chemoleumWetBrakeOilProducts = [
  { name: "TURBO J 20C - 20", price: 6579, weight: "20.00 L", litrePrice: 329 },
  { name: "TURBO J 20C - 210", price: 208, weight: "210.00 L", litrePrice: 208 },
  { name: "TURBO J 20C - 10", price: 214, weight: "10.00 L", litrePrice: 214 },
  { name: "TURBO J 20C - 12X1", price: 339, weight: "1.00 L", litrePrice: 339 },
  { name: "TURBO J 20C - 1x20", price: 339, weight: "1.00 L", litrePrice: 339 },
  { name: "TURBO J 20C - 40", price: 220, weight: "40.00 L", litrePrice: 220 },
  { name: "TURBO J 20C - 55", price: 214, weight: "55.00 L", litrePrice: 214 },
  { name: "TURBO J 20C - 5X4", price: 1899, weight: "5.00 L", litrePrice: 380 },
  { name: "TURBO J20C - 26 Ltr", price: 220, weight: "26.00 L", litrePrice: 220 }
];
const chemoleumDEOProducts = [
  { name: "MULTI GRADE ENGINE OIL - 3.5", price: 1159, weight: "3.50 L", litrePrice: 0 },
  { name: "MULTI GUARD CHHAKADA 20W-40 API CF4 - 12X1.2L", price: 369, weight: "1.20 L", litrePrice: 308 },
  { name: "MULTI GUARD CHHAKADA 20W-40 API CF4 - 20X1.2L", price: 369, weight: "1.20 L", litrePrice: 308 },
  { name: "MULTI GUARD SPECIAL 4T API SL 20W40 - 55", price: 183, weight: "55.00 L", litrePrice: 183 },
  { name: "MULTI GUARD SPECIAL SAE 20W40 - 4X5L NP", price: 1449, weight: "5.00 L", litrePrice: 290 },
  { name: "MULTI GUARD SPECIAL SAE 20W40 CF-4 -12X1L", price: 358, weight: "1.00 L", litrePrice: 358 },
  { name: "MULTI GUARD SPECIAL SAE 20W-40 APICF4/SJ- 4X5L", price: 1559, weight: "5.00 L", litrePrice: 312 },
  { name: "MULTI GUARD SPECIAL SAE 20W40 CF4 - 1X20", price: 369, weight: "1.00 L", litrePrice: 369 },
  { name: "Multi Guard Special SAE 20W40 CF4 - 10", price: 3249, weight: "10.00 L", litrePrice: 325 },
  { name: "Multi Guard Special SAE 20W40 CF4 - 10 NP", price: 2999, weight: "10.00 L", litrePrice: 300 },
  { name: "MULTI GUARD SPECIAL SAE 20W40 CF4 - 12X1L UDY", price: 369, weight: "1.00 L", litrePrice: 369 },
  { name: "MULTI GUARD SPECIAL SAE 20W40 CF4 - 20", price: 5499, weight: "20.00 L", litrePrice: 275 },
  { name: "Multi Guard Special SAE 20W40 CF4 - 210", price: 180, weight: "210.00 L", litrePrice: 180 },
  { name: "Multi Guard Special SAE 20W40 CF4 - 210 UDY", price: 180, weight: "210.00 L", litrePrice: 180 },
  { name: "Multi Guard Special SAE 20W40 CF4 - 26", price: 183, weight: "26.00 L", litrePrice: 183 },
  { name: "Multi Guard Special SAE 20W40 CF4 - 2X6L NP", price: 1950, weight: "6.00 L", litrePrice: 325 },
  { name: "MULTI GUARD SPECIAL SAE 20W40 CF4 - 2X7.5L NP", price: 2599, weight: "7.50 L", litrePrice: 347 },
  { name: "Multi Guard Special SAE 20W40 CF4 - 55", price: 183, weight: "55.00 L", litrePrice: 183 },
  { name: "Multi Guard Special SAE 20W40 CF4 - 6X2", price: 1950, weight: "6.00 L", litrePrice: 325 },
  { name: "MULTI GUARD SPECIAL SAE 20W40 CF4 - 6X3", price: 999, weight: "3.00 L", litrePrice: 333 },
  { name: "MULTI GUARD SPECIAL SAE 20W40 CF4 - 6X3L UDY", price: 999, weight: "3.00 L", litrePrice: 333 },
  { name: "Multi Guard Special SAE 20W40 CF4 - 7.5X2", price: 2599, weight: "7.50 L", litrePrice: 347 },
  { name: "Multi Guard Special SAE 20W40 CF4 - 8.5", price: 2850, weight: "8.50 L", litrePrice: 335 },
  { name: "MULTIGRADE ENGINE OIL - 210", price: 180, weight: "210.00 L", litrePrice: 180 },
  { name: "RED RIDER SAE 20W40 - 0.350x20", price: 133, weight: "0.35 L", litrePrice: 380 },
  { name: "RED RIDER SAE 20W40 - 0.500X20", price: 159, weight: "0.50 L", litrePrice: 318 },
  { name: "RED RIDER SAE 20W40 - 210", price: 168, weight: "210.00 L", litrePrice: 168 },
  { name: "RED RIDER SAE 20W40 - 12X1 (POUCH)", price: 299, weight: "1.00 L", litrePrice: 299 },
  { name: "RED RIDER SAE 20W40 - 26", price: 174, weight: "26.00 L", litrePrice: 174 },
  { name: "RED RIDER SAE 20W40 - 55", price: 171, weight: "55.00 L", litrePrice: 171 },
  { name: "RED RIDER SAE 20W40-UNDYED - 210", price: 168, weight: "210.00 L", litrePrice: 168 },
  { name: "RED RIDER WITH SPOUT - 10X1.2 L", price: 359, weight: "1.20 L", litrePrice: 299 },
  { name: "TURBO 300 SAE 20W-40-APICH4/SL - 1X20", price: 339, weight: "1.00 L", litrePrice: 339 },
  { name: "TURBO 300 SAE 20W40 APICH4/SL - 10L NON PROMO", price: 3588, weight: "10.00 L", litrePrice: 359 },
  { name: "TURBO 300 SAE 20W40 APICH4/SL - 2X8.5L NP", price: 2979, weight: "8.50 L", litrePrice: 350 },
  { name: "TURBO 300 SAE 20W-40-10LTR NON PROMO", price: 3588, weight: "10.00 L", litrePrice: 359 },
  { name: "TURBO 300 SAE 20W40-API CH4/SL - 20X500ML", price: 179, weight: "0.50 L", litrePrice: 358 },
  { name: "TURBO 300 SAE 20W-40-APICH4/SL - 10", price: 3588, weight: "10.00 L", litrePrice: 359 },
  { name: "TURBO 300 SAE 20W-40-APICH4/SL - 12X1L", price: 339, weight: "1.00 L", litrePrice: 339 },
  { name: "TURBO 300 SAE 20W-40-APICH4/SL - 20", price: 5499, weight: "20.00 L", litrePrice: 275 },
  { name: "TURBO 300 SAE 20W-40-APICH4/SL - 210", price: 208, weight: "210.00 L", litrePrice: 208 },
  { name: "TURBO 300 SAE 20W-40-APICH4/SL - 26", price: 214, weight: "26.00 L", litrePrice: 214 },
  { name: "TURBO 300 SAE 20W-40-APICH4/SL - 2X6L", price: 2250, weight: "6.00 L", litrePrice: 375 },
  { name: "TURBO 300 SAE 20W-40-APICH4/SL - 2X7.5L", price: 2950, weight: "7.50 L", litrePrice: 393 },
  { name: "TURBO 300 SAE 20W-40-APICH4/SL - 2X7.5L NP", price: 2950, weight: "7.50 L", litrePrice: 393 },
  { name: "TURBO 300 SAE 20W-40-APICH4/SL - 2X8.5L", price: 2979, weight: "8.50 L", litrePrice: 350 },
  { name: "TURBO 300 SAE 20W-40-APICH4/SL - 4X5L", price: 1788, weight: "5.00 L", litrePrice: 358 },
  { name: "TURBO 300 SAE 20W-40-APICH4/SL - 55", price: 214, weight: "55.00 L", litrePrice: 214 },
  { name: "TURBO 300 SAE 40 - 10", price: 2799, weight: "10.00 L", litrePrice: 280 },
  { name: "TURBO 300 SAE 40 - 12X1", price: 339, weight: "1.00 L", litrePrice: 339 },
  { name: "TURBO 300 SAE 40 - 1X20", price: 339, weight: "1.00 L", litrePrice: 339 },
  { name: "TURBO 300 SAE 40 - 20", price: 4959, weight: "20.00 L", litrePrice: 248 },
  { name: "TURBO 300 SAE 40 - 210", price: 183, weight: "210.00 L", litrePrice: 183 },
  { name: "TURBO 300 SAE 40 - 5X4", price: 1599, weight: "5.00 L", litrePrice: 320 },
  { name: "TURBO 300 SAE 40 - 7.5X2", price: 2599, weight: "7.50 L", litrePrice: 347 },
  { name: "TURBO 300 SAE 40 - 55", price: 190, weight: "55.00 L", litrePrice: 190 },
  { name: "TURBO 300 SEA 40 NP -10 LTR", price: 2799, weight: "10.00 L", litrePrice: 280 },
  { name: "TURBO D SUPER SAE 15W40 - 10", price: 2999, weight: "10.00 L", litrePrice: 300 },
  { name: "TURBO D SUPER SAE 15W40 - 1X20", price: 299, weight: "1.00 L", litrePrice: 299 },
  { name: "TURBO D SUPER SAE 15W40 - 20", price: 5499, weight: "20.00 L", litrePrice: 275 },
  { name: "TURBO D SUPER SAE 15W40 - 210", price: 183, weight: "210.00 L", litrePrice: 183 },
  { name: "TURBO D SUPER SAE 15W40 - 2X7.5L NP", price: 2259, weight: "7.50 L", litrePrice: 301 },
  { name: "TURBO D SUPER SAE 15W40 - 4X4", price: 1260, weight: "4.00 L", litrePrice: 315 },
  { name: "TURBO D SUPER SAE 15W40 - 5X4", price: 1699, weight: "5.00 L", litrePrice: 340 },
  { name: "TURBO D SUPER SAE 15W40 - 7.5X2", price: 2699, weight: "7.50 L", litrePrice: 360 },
  { name: "TURBO D SUPER SAE 15W40 - 10 NP", price: 2999, weight: "10.00 L", litrePrice: 300 },
  { name: "TURBO D SUPER SAE 15W40 - 11 LTR", price: 2950, weight: "11.00 L", litrePrice: 268 },
  { name: "TURBO D SUPER SAE 15W40 - 12X1", price: 299, weight: "1.00 L", litrePrice: 299 },
  { name: "TURBO D SUPER SAE 15W40 - 15", price: 4399, weight: "15.00 L", litrePrice: 293 },
  { name: "TURBO D SUPER SAE 15W40 - 15 NP", price: 4399, weight: "15.00 L", litrePrice: 293 },
  { name: "TURBO D SUPER SAE 15W40 - 20 NP", price: 5499, weight: "20.00 L", litrePrice: 275 },
  { name: "TURBO D SUPER SAE 15W40 - 26 (GD)", price: 190, weight: "26.00 L", litrePrice: 190 },
  { name: "TURBO D SUPER SAE 15W40 - 26 LTR", price: 190, weight: "26.00 L", litrePrice: 190 },
  { name: "TURBO D SUPER SAE 15W40 - 2X6L NP", price: 1850, weight: "6.00 L", litrePrice: 308 },
  { name: "TURBO D SUPER SAE 15W40 - 2X7L", price: 2499, weight: "7.00 L", litrePrice: 357 },
  { name: "TURBO D SUPER SAE 15W40 - 2X7L NP", price: 2499, weight: "7.00 L", litrePrice: 357 },
  { name: "TURBO D SUPER SAE 15W-40 - 55", price: 190, weight: "55.00 L", litrePrice: 190 },
  { name: "TURBO D SUPER SAE 15W40 - 5x2", price: 1899, weight: "5.00 L", litrePrice: 380 },
  { name: "TURBO D SUPER SAE 15W40 - 5X4 NP", price: 1699, weight: "5.00 L", litrePrice: 380 },
  { name: "TURBO D SUPER SAE 15W40 - 6X2", price: 1850, weight: "6.00 L", litrePrice: 340 },
  { name: "TURBO D SUPER SAE 15W40 - 7.5X2 GD", price: 2259, weight: "7.50 L", litrePrice: 308 },
  { name: "TURBO D SUPER SAE 15W40 GD - 210", price: 183, weight: "210.00 L", litrePrice: 301 },
  { name: "TURBO D SUPER SAE 15W40 -12X1 (POUCH)", price: 333, weight: "1.00 L", litrePrice: 183 },
  { name: "TURBO D SUPER SAE 15W40 API-CF4 - 4X3.5L", price: 1899, weight: "3.50 L", litrePrice: 333 },
  { name: "TURBO D SUPER SAE 15W40 API-CF4 - 6X3L", price: 1150, weight: "3.00 L", litrePrice: 543 },
  { name: "TURBO D SUPER SAE 15W40 API-CF4 - 6X3L (GD) RS-50 COUPON", price: 1150, weight: "3.00 L", litrePrice: 383 },
  { name: "TURBO D SUPER SAE 15W40 API-CF4 - 6X3L NP", price: 999, weight: "3.00 L", litrePrice: 383 },
  { name: "TURBO D SUPER SAE 15W40 API-CF4 - 8.5", price: 2399, weight: "8.50 L", litrePrice: 333 },
  { name: "TURBO D SUPER SAE 15W40 API-CF4 - 8.5 NP", price: 2399, weight: "8.50 L", litrePrice: 282 },
  { name: "TURBO D SUPER SAE 15W-40 GD-55", price: 190, weight: "55.00 L", litrePrice: 282 },
  { name: "TURBO D SUPER SAE 15W40-10X1.2L (POUCH)", price: 334, weight: "1.20 L", litrePrice: 190 },
  { name: "TURBO D SUPER SAE 15W-40-API CF4 - 5X2 NON PROMO", price: 1699, weight: "5.00 L", litrePrice: 278 },
  { name: "TURBO GOLD NXG 15W40 (GD)-API CI4\\SL - 4.5X4", price: 1850, weight: "4.50 L", litrePrice: 340 },
  { name: "TURBO GOLD NXG PLUS 15W40 -API CI4 - 2X6L", price: 1950, weight: "6.00 L", litrePrice: 411 },
  { name: "TURBO GOLD SAE 15W40 - 10", price: 3888, weight: "10.00 L", litrePrice: 325 },
  { name: "TURBO GOLD SAE 15W40 - 11", price: 4140, weight: "11.00 L", litrePrice: 389 },
  { name: "TURBO GOLD SAE 15W40 - 1X20", price: 369, weight: "1.00 L", litrePrice: 376 },
  { name: "TURBO GOLD SAE 15W40 - 20", price: 6399, weight: "20.00 L", litrePrice: 369 },
  { name: "TURBO GOLD SAE 15W40 - 210", price: 214, weight: "210.00 L", litrePrice: 320 },
  { name: "TURBO GOLD SAE 15W40 - 2X6 LTR", price: 1950, weight: "6.00 L", litrePrice: 214 },
  { name: "TURBO GOLD SAE 15W40 - 2X7L NP", price: 2399, weight: "7.00 L", litrePrice: 325 },
  { name: "TURBO GOLD SAE 15W40 - 10 NP", price: 3888, weight: "10.00 L", litrePrice: 343 },
  { name: "TURBO GOLD SAE 15W40 - 15", price: 4999, weight: "15.00 L", litrePrice: 389 },
  { name: "TURBO GOLD SAE 15W40 - 15 NP", price: 4999, weight: "15.00 L", litrePrice: 333 },
  { name: "TURBO GOLD SAE 15W40 - 18", price: 5599, weight: "18.00 L", litrePrice: 333 },
  { name: "TURBO GOLD SAE 15W40 - 20 NP", price: 6399, weight: "20.00 L", litrePrice: 311 },
  { name: "TURBO GOLD SAE 15W40 - 26 LTR", price: 220, weight: "26.00 L", litrePrice: 320 },
  { name: "TURBO GOLD SAE 15W40 - 2X7.5L NP", price: 2799, weight: "7.50 L", litrePrice: 220 },
  { name: "TURBO GOLD SAE 15W-40 - 55", price: 220, weight: "55.00 L", litrePrice: 373 },
  { name: "TURBO GOLD SAE 15W40 - 5X4", price: 1899, weight: "5.00 L", litrePrice: 220 },
  { name: "TURBO GOLD SAE 15W40 - 7.5X2", price: 2799, weight: "7.50 L", litrePrice: 380 },
  { name: "TURBO GOLD SAE 15W40 - 8.5L", price: 2850, weight: "8.50 L", litrePrice: 373 },
  { name: "TURBO GOLD SAE 15W40 - 8.5x2", price: 2850, weight: "8.50 L", litrePrice: 335 },
  { name: "TURBO GOLD SAE 15W40 - 8.5x2 NP", price: 2850, weight: "8.50 L", litrePrice: 335 },
  { name: "TURBO GOLD SAE 15W40 GD - 210", price: 214, weight: "210.00 L", litrePrice: 335 },
  { name: "TURBO GOLD SAE 15W-40 (GD) - 55", price: 220, weight: "55.00 L", litrePrice: 214 },
  { name: "TURBO GOLD SAE 15W-40 (NXG) - 2X7L NP", price: 2599, weight: "7.00 L", litrePrice: 220 },
  { name: "TURBO GOLD SAE 15W40 (NXG) - 4X3.5L NP", price: 1159, weight: "3.50 L", litrePrice: 371 },
  { name: "TURBO GOLD SAE 15W-40 (NXG) - 55", price: 228, weight: "55.00 L", litrePrice: 331 },
  { name: "TURBO GOLD SAE 15W40 (NXG) - 5X4", price: 1950, weight: "5.00 L", litrePrice: 228 },
  { name: "TURBO GOLD SAE 15W40 (NXG) - 5X4 NP", price: 1950, weight: "5.00 L", litrePrice: 390 },
  { name: "TURBO GOLD SAE 15W-40 (NXG) - 7X2", price: 2599, weight: "7.00 L", litrePrice: 390 },
  { name: "TURBO GOLD SAE 15W40 -17", price: 5299, weight: "17.00 L", litrePrice: 371 },
  { name: "TURBO GOLD SAE 15W40 API CI4 - 13L", price: 4199, weight: "13.00 L", litrePrice: 312 },
  { name: "TURBO GOLD SAE 15W40 API-CI4 - 12x1L", price: 369, weight: "1.00 L", litrePrice: 323 },
  { name: "TURBO GOLD SAE 15W40 GD - 26 Ltr", price: 220, weight: "26.00 L", litrePrice: 369 },
  { name: "TURBO GOLD SAE 15W40 GD - 50", price: 220, weight: "50.00 L", litrePrice: 220 },
  { name: "TURBO GOLD SAE 15W40 NXG - 210", price: 220, weight: "210.00 L", litrePrice: 220 },
  { name: "TURBO GOLD SAE 15W40 NXG - 3.5x4", price: 1159, weight: "3.50 L", litrePrice: 220 },
  { name: "TURBO GOLD SAE 15W-40-GD -26LTR", price: 220, weight: "26.00 L", litrePrice: 331 },
  { name: "TURBO POWER GENSET TN -10", price: 3222, weight: "10.00 L", litrePrice: 220 },
  { name: "TURBO POWER GENSET-10", price: 3222, weight: "10.00 L", litrePrice: 322 },
  { name: "TURBO PREMIUM 15W40 - 1", price: 432, weight: "1.00 L", litrePrice: 322 },
  { name: "TURBO PREMIUM PLUS 15W40 - 10", price: 3699, weight: "10.00 L", litrePrice: 432 },
  { name: "TURBO PREMIUM PLUS 15W40 - 10 NP", price: 3699, weight: "10.00 L", litrePrice: 370 },
  { name: "TURBO PREMIUM PLUS 15W40 - 12X1", price: 432, weight: "1.00 L", litrePrice: 370 },
  { name: "TURBO PREMIUM PLUS 15W40 - 15", price: 5999, weight: "15.00 L", litrePrice: 432 },
  { name: "TURBO PREMIUM PLUS 15W40 - 20", price: 7349, weight: "20.00 L", litrePrice: 400 },
  { name: "TURBO PREMIUM PLUS 15W40 - 210", price: 214, weight: "210.00 L", litrePrice: 367 },
  { name: "TURBO PREMIUM PLUS 15W40 - 50", price: 220, weight: "50.00 L", litrePrice: 214 },
  { name: "TURBO PREMIUM PLUS 15W40 - 15 NP", price: 5999, weight: "15.00 L", litrePrice: 220 },
  { name: "TURBO PREMIUM PLUS 15W40 - 17", price: 7599, weight: "17.00 L", litrePrice: 400 },
  { name: "TURBO PREMIUM PLUS 15W40 - 18 LTR", price: 7999, weight: "18.00 L", litrePrice: 447 },
  { name: "TURBO PREMIUM PLUS 15W40 - 18 NP", price: 7999, weight: "18.00 L", litrePrice: 444 },
  { name: "TURBO PREMIUM PLUS 15W40 CI4 - 1x20", price: 432, weight: "1.00 L", litrePrice: 444 },
  { name: "TURBO PREMIUM PLUS 15W40 GD - 210", price: 214, weight: "210.00 L", litrePrice: 432 },
  { name: "TURBO PREMIUM PLUS SAE 15W-40 - 11L SPECIAL", price: 4140, weight: "11.00 L", litrePrice: 214 },
  { name: "TURBO PREMIUM PLUS SAE 15W40 - 26", price: 220, weight: "26.00 L", litrePrice: 376 },
  { name: "TURBO PREMIUM PLUS SAE 15W-40 - 55", price: 220, weight: "55.00 L", litrePrice: 220 },
  { name: "TURBO PREMIUM PLUS SAE 15W40 - 5LTR", price: 2399, weight: "5.00 L", litrePrice: 220 },
  { name: "TURBO PREMIUM PLUS SAE 15W-40 API CI4-PLUS - 11 LTR", price: 4140, weight: "11.00 L", litrePrice: 480 },
  { name: "TURBO PREMIUM PLUS SAE 15W40-API CI4 PLUS - 2X7.5L", price: 2688, weight: "7.50 L", litrePrice: 376 },
  { name: "TURBO PREMIUM PLUS SAE 15W40-API CI4 PLUS - 2X7.5L NP", price: 2688, weight: "7.50 L", litrePrice: 358 },
  { name: "TURBO PREMIUM SAE 15W40 - 5x4", price: 2399, weight: "5.00 L", litrePrice: 358 },
  { name: "TURBO SILVER 20W40 -API CH4/SL - 2X6L", price: 2250, weight: "6.00 L", litrePrice: 480 },
  { name: "TURBO SILVER 20W40 API CH4/SL - 10", price: 3588, weight: "10.00 L", litrePrice: 375 },
  { name: "TURBO SILVER 20W40 API CH4/SL - 10 NP", price: 3588, weight: "10.00 L", litrePrice: 359 },
  { name: "TURBO SILVER SAE 20W40 - 5X4", price: 1788, weight: "5.00 L", litrePrice: 359 },
  { name: "TURBO SILVER SAE 20W-40- API CH4/SL - 2X7.5L", price: 2950, weight: "7.50 L", litrePrice: 358 },
  { name: "TURBO SILVER SAE 20W-40- API CH4/SL - 2X7.5L NP", price: 2950, weight: "7.50 L", litrePrice: 393 },
  { name: "TURBO SILVER SAE 20W-40-API CH4/SL - 20", price: 5499, weight: "20.00 L", litrePrice: 393 },
  { name: "TURBO TRACTOR PLUS CI 4 15W40 - 10", price: 3699, weight: "10.00 L", litrePrice: 275 },
  { name: "TURBO TRACTOR PLUS CI 4 15W40 - 10 NP", price: 3699, weight: "10.00 L", litrePrice: 370 },
  { name: "TURBO TRACTOR PLUS CI 4 15W40 - 2X7.5L", price: 265, weight: "7.50 L", litrePrice: 370 },
  { name: "TURBO TRACTOR PLUS CI 4 15W40 - 8.5 NP", price: 2799, weight: "8.50 L", litrePrice: 265 },
  { name: "TURBO TRACTOR PLUS CI 4 15W40 - 8.5L", price: 2799, weight: "8.50 L", litrePrice: 329 },
  { name: "TURBO TRACTOR PLUS CI 4 15W40 - 8.5L", price: 2799, weight: "8.50 L", litrePrice: 329 }
];
const chemoleumCoolantProducts = [
  { name: "ECO KOOL - 12X1L", price: 249, weight: "1.00 L", litrePrice: 249 },
  { name: "ECO KOOL - 1x20", price: 249, weight: "1.00 L", litrePrice: 249 },
  { name: "ECO KOOL - 210", price: 119, weight: "210.00 L", litrePrice: 119 },
  { name: "ECO KOOL - 55", price: 122, weight: "55.00 L", litrePrice: 122 },
  { name: "ECO KOOL - 6X3L", price: 685, weight: "3.00 L", litrePrice: 228 },
  { name: "EP 0 GREASE - 18 KG", price: 5199, weight: "18.00 L", litrePrice: 289 },
  { name: "TURBO KOOL - 1X20", price: 348, weight: "1.00 L", litrePrice: 348 },
  { name: "TURBO KOOL - 210", price: 156, weight: "210.00 L", litrePrice: 156 },
  { name: "TURBO KOOL - 26", price: 149, weight: "26.00 L", litrePrice: 149 },
  { name: "TURBO KOOL - 55", price: 159, weight: "55.00 L", litrePrice: 159 },
  { name: "TURBO KOOL - 0.5x20", price: 178, weight: "0.50 L", litrePrice: 356 },
  { name: "TURBO KOOL - 12X1L", price: 348, weight: "1.00 L", litrePrice: 348 },
  { name: "TURBO KOOL - 20", price: 3500, weight: "20.00 L", litrePrice: 175 },
  { name: "TURBO KOOL - 3x6", price: 1049, weight: "3.00 L", litrePrice: 350 },
  { name: "TURBO KOOL - 5X4", price: 1899, weight: "5.00 L", litrePrice: 380 },
  { name: "TURBO KOOL PRE MIX - 1x20", price: 247, weight: "1.00 L", litrePrice: 247 },
  { name: "TURBO KOOL PRE-MIX - 12X1L", price: 247, weight: "1.00 L", litrePrice: 247 }
];
  
  const chemoleumAdblueProducts = [
    { name: "ECO BLUE DIESEL EXHAUST FLUID - 10", price: 999, weight: "10.00 L", litrePrice: 100 },
    { name: "ECO BLUE DIESEL EXHAUST FLUID - 20", price: 1699, weight: "20.00 L", litrePrice: 85 },
    { name: "ECO BLUE DIESEL EXHAUST FLUID - 210", price: 71, weight: "210.00 L", litrePrice: 71 },
    { name: "ECO BLUE DIESEL EXHAUST FLUID - 26", price: 73, weight: "26.00 L", litrePrice: 73},
    { name: "ECO BLUE DIESEL EXHAUST FLUID - 55", price: 71, weight: "55.00 L", litrePrice: 71 }
  ];
  return (
    <div className="automotive-section">
      <div className="auto-card">
        <h2>Automotive Products</h2>
        <p>
          Discover our wide range of automotive products designed to enhance vehicle 
          performance and reliability. From engine components to advanced electronic 
          systems, we provide top-quality solutions for all your automotive needs.
        </p>
      </div>
      
      <div className="buttons-container">
        <button 
          className="brand-button"
          onClick={() => {
            setShowBalmerolCategories(!showBalmerolCategories);
            setShowChemoleumCategories(false);
            setActiveBalmerolCategory(null);
            setActiveChemoleumCategory(null);
          }}
        >
          Balmerol
        </button>
        <button 
          className="brand-button"
          onClick={() => {
            setShowChemoleumCategories(!showChemoleumCategories);
            setShowBalmerolCategories(false);
            setActiveBalmerolCategory(null);
            setActiveChemoleumCategory(null);
          }}
        >
          Chemoleum
        </button>
      </div>

      {showBalmerolCategories && (
        <div className="categories-container">
          <h3>Balmerol Categories:</h3>
          <div className="category-buttons">
            {balmerolCategories.map((category, index) => (
              <button
                key={index}
                className="category-button"
                onClick={() => setActiveBalmerolCategory(category)}
              >
                {category}
              </button>
            ))}
          </div>

          {activeBalmerolCategory && (
            <div className="section-indicator">
              <h3>You are in the {activeBalmerolCategory} section</h3>
            </div>
          )}

          {activeBalmerolCategory === "Greases" && (
            <div className="products-grid">
              {greasesProducts.map((product, index) => (
                <div key={index} className="product-card">
                  <h4>{product.name}</h4>
                  <p>Price: ₹{product.price}</p>
                  <p>Weight: {product.weight}</p>
                </div>
              ))}
            </div>
          )}

          {activeBalmerolCategory === "Coolant" && (
            <div className="products-grid">
              {coolantProducts.map((product, index) => (
                <div key={index} className="product-card">
                  <h4>{product.name}</h4>
                  <p>Price: ₹{product.price}</p>
                  <p>Weight: {product.weight}</p>
                </div>
              ))}
            </div>
          )}

          {activeBalmerolCategory === "Diesel Engine Oil" && (
            <div className="products-grid">
              {dieselEngineOilProducts.map((product, index) => (
                <div key={index} className="product-card">
                  <h4>{product.name}</h4>
                  <p>Price: ₹{product.price}</p>
                  <p>Weight: {product.weight}</p>
                </div>
              ))}
            </div>
          )}

          {activeBalmerolCategory === "Diesel Engine" && (
            <div className="products-grid">
              {dieselEngineProducts.map((product, index) => (
                <div key={index} className="product-card">
                  <h4>{product.name}</h4>
                  <p>Price: ₹{product.price}</p>
                  <p>Weight: {product.weight}</p>
                </div>
              ))}
            </div>
          )}

          {activeBalmerolCategory === "Two Wheeler" && (
            <div className="products-grid">
              {twoWheelerProducts.map((product, index) => (
                <div key={index} className="product-card">
                  <h4>{product.name}</h4>
                  <p>Price: ₹{product.price}</p>
                  <p>Weight: {product.weight}</p>
                </div>
              ))}
            </div>
          )}

          {activeBalmerolCategory === "Transmission Oil" && (
            <div className="products-grid">
              {transmissionOilProducts.map((product, index) => (
                <div key={index} className="product-card">
                  <h4>{product.name}</h4>
                  <p>Price: ₹{product.price}</p>
                  <p>Weight: {product.weight}</p>
                </div>
              ))}
            </div>
          )}

          {activeBalmerolCategory === "Gear Oil" && (
            <div className="products-grid">
              {gearOilProducts.map((product, index) => (
                <div key={index} className="product-card">
                  <h4>{product.name}</h4>
                  <p>Price: ₹{product.price}</p>
                  <p>Weight: {product.weight}</p>
                </div>
              ))}
            </div>
          )}

          {activeBalmerolCategory === "Hydraulic Oil" && (
            <div className="products-grid">
              {hydraulicOilProducts.map((product, index) => (
                <div key={index} className="product-card">
                  <h4>{product.name}</h4>
                  <p>Price: ₹{product.price}</p>
                  <p>Weight: {product.weight}</p>
                </div>
              ))}
            </div>
          )}

          {activeBalmerolCategory === "Multigrade Engine Oil" && (
            <div className="products-grid">
              {multigradeEngineOilProducts.map((product, index) => (
                <div key={index} className="product-card">
                  <h4>{product.name}</h4>
                  <p>Price: ₹{product.price}</p>
                  <p>Weight: {product.weight}</p>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {showChemoleumCategories && (
        <div className="categories-container">
          <h3>Chemoleum Categories:</h3>
          <div className="category-buttons">
            {chemoleumCategories.map((category, index) => (
              <button
                key={index}
                className="category-button"
                onClick={() => setActiveChemoleumCategory(category)}
              >
                {category}
              </button>
            ))}
          </div>

          {activeChemoleumCategory && (
            <div className="section-indicator">
              <h3>You are in the {activeChemoleumCategory} section</h3>
            </div>
          )}

          {activeChemoleumCategory === "Grease" && (
            <div className="products-grid">
              {chemoleumGreaseProducts.map((product, index) => (
                <div key={index} className="product-card">
                  <h4>{product.name}</h4>
                  <p>Price: ₹{product.price}</p>
                  <p>Weight: {product.weight}</p>
                  <p>Price per Litre: {product.litrePrice}</p>
                </div>
              ))}
            </div>
          )}

          {activeChemoleumCategory === "2W" && (
            <div className="products-grid">
              {chemoleum2WProducts.map((product, index) => (
                <div key={index} className="product-card">
                  <h4>{product.name}</h4>
                  <p>Price: ₹{product.price}</p>
                  <p>Weight: {product.weight}</p>
                  <p>Price per Litre: {product.litrePrice}</p>
                </div>
              ))}
            </div>
          )}

{activeChemoleumCategory === "3W" && (
  <div className="products-grid">
    {chemoleum3WProducts.map((product, index) => (
      <div key={index} className="product-card">
        <h4>{product.name}</h4>
        <p>Price: ₹{product.price}</p>
        <p>Weight: {product.weight}</p>
        <p>Price per Litre: {product.litrePrice}</p>
      </div>
    ))}
  </div>
)}
{activeChemoleumCategory === "PCMO" && (
  <div className="products-grid">
    {chemoleumPCMOProducts.map((product, index) => (
      <div key={index} className="product-card">
        <h4>{product.name}</h4>
        <p>Price: ₹{product.price}</p>
        <p>Weight: {product.weight}</p>
        <p>Price per Litre: {product.litrePrice}</p>
      </div>
    ))}
  </div>
)}
{activeChemoleumCategory === "Gear/X mission" && (
  <div className="products-grid">
    {chemoleumGearXmissionProducts.map((product, index) => (
      <div key={index} className="product-card">
        <h4>{product.name}</h4>
        <p>Price: ₹{product.price}</p>
        <p>Weight: {product.weight}</p>
        <p>Price per Litre: {product.litrePrice}</p>
      </div>
    ))}
  </div>
)}
{activeChemoleumCategory === "Wet Brake Oil" && (
  <div className="products-grid">
    {chemoleumWetBrakeOilProducts.map((product, index) => (
      <div key={index} className="product-card">
        <h4>{product.name}</h4>
        <p>Price: ₹{product.price}</p>
        <p>Weight: {product.weight}</p>
        <p>Price per Litre: {product.litrePrice}</p>
      </div>
    ))}
  </div>
)}
{activeChemoleumCategory === "DEO" && (
  <div className="products-grid">
    {chemoleumDEOProducts.map((product, index) => (
      <div key={index} className="product-card">
        <h4>{product.name}</h4>
        <p>Price: ₹{product.price}</p>
        <p>Weight: {product.weight}</p>
        <p>Price per Litre: {product.litrePrice}</p>
      </div>
    ))}
  </div>
)}
 {activeChemoleumCategory === "Coolant" && (
    <div className="products-grid">
      {chemoleumCoolantProducts.map((product, index) => (
        <div key={index} className="product-card">
          <h4>{product.name}</h4>
          <p>Price: ₹{product.price}</p>
          <p>Weight: {product.weight}</p>
          <p>Price per Litre: {product.litrePrice}</p>
        </div>
      ))}
    </div>
  )}


{activeChemoleumCategory === "Adblue" && (
  <div className="products-grid">
    {chemoleumAdblueProducts.map((product, index) => (
      <div key={index} className="product-card">
        <h4>{product.name}</h4>
        <p>Price: ₹{product.price}</p>
        <p>Weight: {product.weight}</p>
        <p>Price per Litre: {product.litrePrice}</p>
      </div>
    ))}
  </div>
)}
        </div>
      )}
    </div>
  );
}

export default Automotive;